import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import "react-toastify/dist/ReactToastify.css";
import { fill_action } from "../../../actions/common_action/fillList_action";
import { Tab, Nav } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../utils/Loader";
import JoditEditor from "jodit-react";
import purify from 'dompurify'
import {
  responseError, toastError, toastSuccess, juryActionId, milestoneAEActionId, milestoneAPActionId,
  categoryActionId, applicationTypeActionId, nominationProcessActionId,
  targetApplicantActionId, awardCategoryActionId, sectionAPActionId,
  controlTypeAPActionId, mandatoryAPActionId,
  scoringModeActionId, scoringOptionsActionId, scoringRoundActionId,
  countryActionId, stateActionId, fileFormatActionId, automatedTypeActionId
} from "../../../utils/constants";
import Header from "../../../common_components/Header";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import {
  award_event_detail_action, insert_milestoneMaster_action,
  awardEventMilestone_insertUpdate_action, awardEventJury_insertUpdate_action,
  award_profile_detail_action, insertUpdate_awardProfile_action,
  insertUpdate_awardProfile_applicationSection_action,
  insertUpdate_awardProfile_scoringPattern_action,
  awardProfileMilestone_insertUpdate_action,
  awardProfile_delete_action, awardProfile_formPublish_action,
  awardProfileApplicationFee_insertUpdate_action, awardProfile_changeSeq_action
} from "../../../actions/adminModule_action/awardEvent_action";
import Footer from "../../../common_components/Footer";
import MobileHeader from "../../../common_components/mobileHeader";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderColor: "#c9c9c9",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#80bdff",
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    borderRadius: "14px",
    padding: "4px",
    backgroundColor: "#00BCD4",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "white",
    fontSize: "12px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "white",
    "&:hover": {
      backgroundColor: "#00BCD4",
      color: "#fff", // Blue border color on hover
    }, // Remove icon color for selected value
  }),
};
const joditConfig = {
  readonly: false,
  height: 500,
  placeholder: "",
  disableBeautify: true,
  useAceEditor: false,
  uploader: { insertImageAsBase64URI: true },
  showAbout: false,
  showPoweredBy: false,
  buttons: [
    'bold', 'strikethrough', 'underline', 'italic', '|',
    'ul', 'ol', '|',
    'outdent', 'indent', '|', 'image', 'video', 'table', 'link', '|',
    'fontsize', 'brush', 'paragraph', '|',
    'align', 'fullsize', "undo", "redo", "search", '|',
    'source', // <-- This is the code editor toggle
    {
      name: "more",
      iconURL: "https://cdn-icons-png.flaticon.com/512/130/130884.png",
      tooltip: "More Options",
      list: ["superscript", "subscript", "copyformat", "print", "hr", 'copyformat'],
    },
  ],
  toolbarAdaptive: false,
  toolbarSticky: false,
  toolbarButtonSize: "middle",
  buttonsXS: [
    'bold', 'image', '|', 'brush', 'paragraph', '|',
    'align', '|', 'undo', 'redo', '|', 'eraser', 'dots', 'more', 'source' // Added here too
  ],
  buttonsSM: ["bold", "italic", "underline", "link", "more", "source"], // Added here too
  style: {
    toolbar: {
      display: "flex",
      justifyContent: "space-between"
    },
  },
  dropdown: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "10px",
    padding: "10px",
  },
  defaultStyle: 'font-family: sans serif; font-size: 14px;',
  placeholder: "",
};
class AwardEventDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      publishView: false, From_date: "", To_date: "", award_address: "",
      award_state: "", award_country: "", user_id: "", award_event_id: "",
      Event_Name: "", Event_Description: "", weightage_round1: '', launch_date: '',
      weightage_round1Note: 'Note: Summation of Round 1 & Round 2 weightage should be equal to 100',
      weightage_round1Err: '', weightage_round2: '',
      //awardErr
      EventNameErr: '', From_dateErr: '', To_dateErr: '', launch_dateErr: '', award_addressErr: '', award_stateErr: '', award_countryErr: '',
      //components bool
      profile_seq_no: '', milestoneMasterMode: "", isAwardProfileModal: false, isApplicationSectionModal1: false,
      isApplicationSectionModal2: false, isInstructionsOpen: false,
      APOpenMode: '', isSectionEdit: null, applicationSectionNameList: [],
      award_event_profile_declaration: '', award_event_profile_declaration_message: '',
      applicationSectionFieldList: [], draggingIndexField: null, draggingSeqNoCategory: '',
      sectionFieldDetail: {
        award_event_profile_id: '',
        award_event_profile_form_section_id: '',
        award_event_profile_section_fields_id: '',
        section_name: '', fieldname: '', controltype_id: '',
        max_length: '', is_mandatory: '', max_size: '',
        file_format: '', seq_no: '', options: [],
        fileFormats: [], newOption: ''
      }, editingOptionIndex: null, editingOptionText: '',
      applicationSectionOptionsList: [
        {
          award_event_profile_id: '', award_event_profile_section_fields_id: '',
          options: [], fieldname: '', section_name: ''
        }
      ],
      award_event_profile_form_section_id: '', award_event_profile_section_fields_id: '',
      isLoading: false,
      is_active: false,
      juryNameSelected: [],
      applicantNameSelected: [],
      categoryNameSelected: [],
      showNewAwardCategoryRow: false,
      showNewRowJury: false,
      editingRowIndex: -1,
      editIndex: "",
      //const main form
      jury_id: "",
      countryErr: "",
      // fillLists
      juryNameFill: [],
      categoryFillList: [], applicantTypeFillList: [], nominationProcessFillList: [],
      targetApplicantFillList: [], awardCategoryFillList: [], sectionAPFillList: [],
      controlTypeAPFillList: [], mandatoryAPFillList: [], scoringModeFillList: [],
      scoringOptionsFillList: [], scoringRoundFillList: [],
      stateFillList: [], countryFillList: [], fileFormatFillList: [], fileFormatOptionFillList: [], automatedTypeFillList: [],
      milestoneFillListAE: [],
      milestoneDetailAE: {
        isSelected: false,
        milestone_id: '',
        milestone_name: '',
        milestone_date: null,
        is_visible_to_applicant: false,
        stage_name: '',
      },
      editedMilestoneRowIndexAE: null,
      editedMilestoneRowDataAE: {},
      showNewMilestoneRowAE: false,

      milestoneFillListAP: [],
      milestoneDetailAP: {
        isSelected: false,
        milestone_id: '',
        milestone_name: '',
        milestone_date: null,
        is_visible_to_applicant: false,
        stage_name: '',
      },
      editedMilestoneRowIndexAP: null,
      editedMilestoneRowDataAP: {},
      showNewMilestoneRowAP: false,
      //pricing
      applicationFeeList: [],
      applicationFeeDetails: {
        applicant_type_pricing_id: '',
        applicant_type_id: '',
        rate_inr: null, rate_usd: null,
      },
      editedPricingRowIndex: null,
      editedPricingRowData: {},

      awardCategoryList: [],
      awardCategoryDetail: {
        award_event_profile_id: '', award_name: "", is_active: 1,
      },
      awardEventJuryList: [], awardEventJuryDetails: [], editedRowIndexJury: -1,
      //scoring pattern
      showNewScoringPatternRow: false,
      editedScoringPatternRowIndex: null,
      editedScoringPatternRowData: {},
      scoringPatternList: [],
      isOptionScoreOpenMode: '',
      isOptionScoreOpen: false,
      scoringPatternDetail: {
        scoring_pattern_id: '',
        round_id: "", scoring_mode_id: "", section_fields_id: '', marking_pattern_name: '',
        sp_name: "", max_score: "", options: [], description: '', scoring_formula: '', table_id: '', automated_type: '',
        tickOptions: [], uploadOptions: []
      },
      modalOptionsDetails: [], optionsViewType: null,
      scoreLeft: '',
      //options modal for ticks
      tickOptions: [], usedNumbers: [],
      //upload options
      uploadOptions: [],

      //award category
      editedAwardCategoryRowIndex: null,
      editedAwardCategoryRowData: {},
      //jury
      editedRowIndexJury: null,
      editedRowDataJury: {},

      // input validate
      NameErr: "",
      //award profile
      award_event_profile_id: "", award_name: "", category_id: "",
      description: "", applicant_type_id: "", target_applicant_id: "",
      award_type: "", eligibility_criteria: "", screening_process: "",
      jury_selection_criteria: "", nomination_process_id: "", list_of_supporting_elements: "",
      theme: '', important_instructions: '', category_names: "", section_label: '',
      is_gst_applicable: null, publish_status: "", publishSubmitType: null, draggingIndexCategory: null,
      //award profile err
      award_nameErr: '', category_idErr: '', applicant_type_idErr: '',
      target_applicant_idErr: '', award_typeErr: '', nomination_process_idErr: '',
      descriptionErr: '', eligibility_criteriaErr: '', screening_processErr: '',
      jury_selection_criteriaErr: '', is_gst_applicableErr: '', section_labelErr: '',
      list_of_supporting_elementsErr: '', themeErr: '', important_instructionsErr: '',
    };
    this.addSection = this.addSection.bind(this);
    this.editOption = this.editOption.bind(this);
    this.stableJoditConfigReadOnly = { ...joditConfig, readonly: true };
    this.stableJoditConfigNormal = { ...joditConfig, readonly: false };
    // // Create debounced update functions for each field
    // this.debouncedUpdateState = {};
    // ['description', 'eligibility_criteria', 'jury_selection_criteria', 'screening_process', 'list_of_supporting_elements', 'theme', 'important_instructions', 'award_event_profile_declaration', 'award_event_profile_declaration_message'].forEach(field => {
    //   this.debouncedUpdateState[field] = debounce(this.updateState.bind(this, field), 1000);
    // });
  }
  updateState(field, value) {
    this.setState({ [field]: value });
  }

  handleAwardProfileEditor = (newContent, type) => {
    this.setState({ [type]: newContent });
  }
  componentDidMount() {
    window.scroll(0, 0)
    const { user_id } = this.state;
    if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }

    setTimeout(() => {
      {
        sessionStorage.getItem("role_id") == 2 ? (
          this.props.navigate("/login")
        ) : <></>
      }
    }, 10);

    this.setState({
      user_id: sessionStorage.getItem("user_id") || "",
    });

    this.getFillList(milestoneAEActionId, user_id, "", "");
    this.getFillList(milestoneAPActionId, user_id, "", "");
    this.getFillList(juryActionId, user_id, "", "");
    this.getFillList(categoryActionId, user_id, "", "");
    this.getFillList(applicationTypeActionId, user_id, "", "");
    this.getFillList(nominationProcessActionId, user_id, "", "");
    this.getFillList(targetApplicantActionId, user_id, "", "");
    this.getFillList(awardCategoryActionId, user_id, "", this.props.location.state?.award_event_id);
    this.getFillList(sectionAPActionId, user_id, "", "");
    this.getFillList(controlTypeAPActionId, user_id, "", "");
    this.getFillList(mandatoryAPActionId, user_id, "", "");
    this.getFillList(scoringModeActionId, user_id, "", "");
    this.getFillList(scoringOptionsActionId, user_id, "", "");
    this.getFillList(scoringRoundActionId, user_id, "", "");
    this.getFillList(countryActionId, user_id, "", "");
    this.getFillList(stateActionId, user_id, "", "");
    this.getFillList(fileFormatActionId, user_id, "", "");
    this.getFillList(automatedTypeActionId, user_id, "", "");
    if (this.props.location.state?.award_event_id) {
      setTimeout(() => {
        this.setState({ award_event_id: this.props.location.state.award_event_id, }, () => {
          this.getAwardEventDetails();
        })
      }, 1000);
    }
  }
  getFillList(value, user_id, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        user_id == "" || user_id == null ? null : user_id,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (value == milestoneAEActionId) {
            this.setState({
              milestoneFillListAE: data.data.length > 0 ? data.data : [],
            });
          }
          if (value == milestoneAPActionId) {
            this.setState({
              milestoneFillListAP: data.data.length > 0 ? data.data : [],
            });
          }
          if (value == juryActionId) {
            var tempEventArr = [];
            for (var i = 0; i < data.data.length; i++) {
              var eventObj = {};
              eventObj.label = data.data[i].juryName;
              eventObj.value = data.data[i].jury_id;
              eventObj.specialization = data.data[i].specialization
              tempEventArr.push(eventObj);
            }
            this.setState({ juryNameFill: tempEventArr, isLoading: false });
          }
          if (value == categoryActionId) {
            var tempCategoryArr = [];
            for (var i = 0; i < data.data.length; i++) {
              var catergoryObj = {};
              catergoryObj.label = data.data[i].category_name;
              catergoryObj.value = data.data[i].category_id;
              tempCategoryArr.push(catergoryObj);
            }
            this.setState({
              categoryFillList: tempCategoryArr,
            });
          }
          if (value == applicationTypeActionId) {
            var tempEventArr = [];
            for (var i = 0; i < data.data.length; i++) {
              var eventObj = {};
              eventObj.label = data.data[i].applicant_name;
              eventObj.value = data.data[i].applicant_type_id;
              tempEventArr.push(eventObj);
            }
            this.setState({ applicantTypeFillList: tempEventArr, isLoading: false });
          }
          if (value == nominationProcessActionId) {
            this.setState({
              nominationProcessFillList: data.data,
            });
          }
          if (value == targetApplicantActionId) {
            this.setState({
              targetApplicantFillList: data.data,
            });
          }
          if (value == awardCategoryActionId) {
            this.setState({
              awardCategoryFillList: data.data,
              awardCategoryList: data.data
            });
          }
          if (value == sectionAPActionId) {
            this.setState({
              sectionAPFillList: data.data,
            });
          }
          if (value == controlTypeAPActionId) {
            this.setState({
              controlTypeAPFillList: data.data,
            });
          }
          if (value == mandatoryAPActionId) {
            this.setState({
              mandatoryAPFillList: data.data,
            });
          }
          if (value == scoringModeActionId) {
            this.setState({
              scoringModeFillList: data.data,
            });
          }
          if (value == scoringRoundActionId) {
            this.setState({
              scoringRoundFillList: data.data,
            });
          }
          if (value == scoringOptionsActionId) {
            this.setState({
              scoringOptionsFillList: data.data,
            });
          }
          if (value == stateActionId) {
            this.setState({
              stateFillList: data.data,
            });
          }
          if (value == countryActionId) {
            this.setState({
              countryFillList: data.data,
            });
          } if (value == automatedTypeActionId) {
            this.setState({
              automatedTypeFillList: data.data,
            });
          }
          if (value == fileFormatActionId) {
            var tempEventArr = [];
            for (var i = 0; i < data.data.length; i++) {
              var eventObj = {};
              eventObj.label = data.data[i].format_type;
              eventObj.value = data.data[i].format_id;
              tempEventArr.push(eventObj);
            }
            this.setState({ fileFormatFillList: tempEventArr, fileFormatOptionFillList: data.data, isLoading: false });
          }
        } else {
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  getAwardEventDetails = async () => {
    const { award_event_id } = this.state;
    this.setState({ isLoading: true });
    try {
      const data = await this.props.award_event_detail_action(award_event_id);
      if (data.error !== 1) {
        const enrichedMilestoneFillList = await this.processMilestoneData(
          this.state.milestoneFillListAE,
          data.data[1]
        );
        const awardEventJuryDetails = this.mapAwardEventJuryDetails(data.data[3], data.data[2]);
        const convertDateFormat = (dateString) => {
          if (!dateString) return null;
          const [day, month, year] = dateString.split("-");
          return `${year}-${month}-${day}`;
        };
        const formatDateTime = (isoDate) => {
          if (!isoDate) return "";
          const date = new Date(isoDate);
          const formattedDate = date.toISOString().slice(0, 16); // Format as YYYY-MM-DDTHH:mm
          return formattedDate;
        };
        const sortedAwardCategoryList = [...data.data[2]].sort((a, b) => a.seq_no - b.seq_no);

        this.setState({
          award_event_id: data.data[0][0]["award_event_id"],
          Event_Name: data.data[0][0]["Event_Name"],
          award_address: data.data[0][0]["award_address"],
          award_state: data.data[0][0]["award_state"],
          award_country: data.data[0][0]["award_country"],
          weightage_round1: data.data[0][0]["weightage_round1"],
          weightage_round2: data.data[0][0]["weightage_round2"],
          is_active: data.data[0][0]["is_active"],
          From_date: convertDateFormat(data.data[0][0]["From_date"]),
          To_date: convertDateFormat(data.data[0][0]["To_date"]),
          launch_date: formatDateTime(data.data[0][0]["launch_date"]),
          Event_Description: data.data[0][0]["Event_Description"],
          milestoneFillListAE: enrichedMilestoneFillList,
          awardCategoryList: sortedAwardCategoryList,
          awardEventJuryDetails,
          isLoading: false,
        });
      } else {
        this.setState({ isLoading: false });
      }
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  processMilestoneData = async (milestoneFillListAE, milestoneListFromAPI) => {
    if (!Array.isArray(milestoneListFromAPI)) {
      return milestoneFillListAE;
    }
    return milestoneFillListAE.map(existingMilestone => {
      const matchingMilestone = milestoneListFromAPI.find(
        apiMilestone => apiMilestone.Milestone_id === existingMilestone.milestone_id
      );
      return {
        ...existingMilestone,
        isSelected: !!matchingMilestone,
        milestone_date: matchingMilestone?.milestone_date || null,
        is_visible_to_applicant: matchingMilestone?.is_visible_to_applicant || null,
        stage_name: matchingMilestone?.stage_name || null,
        is_fixed: matchingMilestone?.is_fixed || null,
      };
    });
  };

  mapAwardEventJuryDetails(juryData, awardCategories) {
    const juryNameSelected = juryData?.map(jury => ({
      label: jury.jury,
      value: jury.jury_id,
      specialization: jury.specialization,
    }));
    const mappedJuries = juryData?.map(jury => {
      const mappedJury = {
        jury_id: jury.jury_id,
        jury: jury.jury,
        specialization: jury.specialization,
      };
      awardCategories.forEach(category => {
        mappedJury[category.award_event_profile_id] = {
          factor_value: jury[category.award_name] || null,
          isChecked: jury[category.award_name] ? true : false,
        };
      });

      return mappedJury;
    });

    this.setState({ juryNameSelected });
    return mappedJuries;
  }

  toggleModalAwardProfileOpen(APOpenMode, award_event_profile_id) {
    const { applicantTypeFillList, award_event_id, categoryFillList, weightage_round1 } = this.state
    if (award_event_id) {
      this.props.award_profile_detail_action(award_event_id, award_event_profile_id)
        .then((data) => {
          if (data.error !== 1) {
            const awardProfileData = data.data[0][0];
            const sectionName = data.data[1];
            const sectionFields = data.data[2];
            const sectionOptions = data.data[3];
            const scoringOptions = data?.data?.[5] ?? [];
            const scoringTickOptions = data?.data?.[8] ?? [];
            const scoringUploadOptions = data?.data?.[9] ?? [];
            const scoringPatternList = (data?.data?.[4] ?? []).map((pattern, i) => {
              const matchingOptions = (scoringOptions)
                .filter(option =>
                  option?.award_event_profile_id === pattern?.award_event_profile_id &&
                  option?.scoring_pattern_id === pattern?.scoring_pattern_id
                )
                .map(option => ({
                  scoring_pattern_id: option?.scoring_pattern_id,
                  options_id: option?.award_event_profile_section_fields_options_id,
                  options: option?.options ?? '',
                  score_value: option?.score ?? 0,
                  award_event_profile_scoring_pattern_options_id: option?.award_event_profile_scoring_pattern_options_id ?? 0,
                }));
              const matchingTickOptions = scoringTickOptions
                .filter(option =>
                  option?.award_event_profile_id === pattern?.award_event_profile_id &&
                  option?.award_event_profile_scoring_pattern_id === pattern?.scoring_pattern_id
                )
                .map(option => ({
                  scoring_pattern_id: option?.award_event_profile_scoring_pattern_id,
                  section_fields_id: option?.section_fields_id,
                  no_of_ticks: option?.no_of_ticks ?? 0,
                  score: option?.score ?? 0,
                }));

              const matchingUploadOptions = scoringUploadOptions
                .filter(option =>
                  option?.award_event_profile_id === pattern?.award_event_profile_id &&
                  option?.award_event_profile_scoring_pattern_id === pattern?.scoring_pattern_id
                )
                .map(option => ({
                  scoring_pattern_id: option?.award_event_profile_scoring_pattern_id,
                  section_fields_id: option?.section_fields_id,
                  upload_format: option?.upload_format ?? '',
                  score: option?.score ?? 0,
                }));

              return {
                ...pattern,
                is_active: 1,
                table_id: i + 1,
                options: matchingOptions,
                tickOptions: matchingTickOptions,
                uploadOptions: matchingUploadOptions,
              };
            });
            const totalMaxScore = scoringPatternList.reduce((sum, pattern) => {
              return sum + (pattern.max_score || 0);
            }, 0);
            const scoreLeft = weightage_round1 - totalMaxScore;
            this.setState({
              scoreLeft: scoreLeft,
            });
            const milestoneList = data.data[6];
            const applicantPricingList = data.data[7];

            const selectedApplicantIds = awardProfileData?.applicant_type_ids?.split(',').map(id => id.trim());

            const matchedApplicants = applicantTypeFillList.
              filter(item => selectedApplicantIds?.includes(item.value.toString()));
            const applicantPricingListMap = matchedApplicants.map(data => {
              const pricing = applicantPricingList.find(pricing => pricing.applicant_type_id === data.value);
              return {
                applicant_type_pricing_id: pricing?.applicant_type_pricing_id || null,
                applicant_type_id: data.value,
                applicantType: data.label,
                rate_inr: pricing ? (pricing?.rate_inr ?? 0) : null,
                rate_usd: pricing ? (pricing?.rate_usd ?? 0) : null,
              };
            });
            this.setState({ applicationFeeList: applicantPricingListMap, applicantNameSelected: matchedApplicants })

            const mappedSectionFields = sectionFields.map(field => {
              const matchingOptions = sectionOptions
                .filter(option => option.award_event_profile_section_fields_id === field.award_event_profile_section_fields_id)
                .map(option => option.options);
              const matchingOptionsId = sectionOptions
                .filter(option => option.award_event_profile_section_fields_id === field.award_event_profile_section_fields_id)
                .map(option => option.award_event_profile_section_fields_options_id);
              return {
                ...field,
                options: matchingOptions,
                optionsId: matchingOptionsId
              };
            });
            const processedCategoryID = awardProfileData?.category_id.split(',').map(id => id.trim());
            const matchedCategories = categoryFillList.
              filter(item => processedCategoryID?.includes(item.value.toString()));
            this.setState({ categoryNameSelected: matchedCategories })

            this.setState({
              award_event_profile_id: awardProfileData?.award_event_profile_id,
              award_event_id: awardProfileData?.award_event_id ? awardProfileData.award_event_id : award_event_id,
              award_name: awardProfileData?.award_name,
              section_label: awardProfileData?.section_label,
              is_gst_applicable: awardProfileData?.is_gst_applicable,
              publish_status: awardProfileData?.publish_status,
              // applicantNameSelected: awardProfileData?.applicant_type_ids?.split(','),
              nomination_process_id: awardProfileData?.nomination_process_id,
              target_applicant_id: awardProfileData?.target_applicant_id,
              award_type: awardProfileData?.award_type,
              description: awardProfileData?.description,
              eligibility_criteria: awardProfileData?.eligibility_criteria,
              jury_selection_criteria: awardProfileData?.jury_selection_criteria,
              list_of_supporting_elements: awardProfileData?.list_of_supporting_elements,
              screening_process: awardProfileData?.screening_process,
              profile_seq_no: awardProfileData?.seq_no,
              theme: awardProfileData?.theme,
              category_names: awardProfileData?.category_names,
              important_instructions: awardProfileData?.important_instructions,
              award_event_profile_declaration: awardProfileData?.award_event_profile_declaration,
              award_event_profile_declaration_message: awardProfileData?.award_event_profile_declaration_message,
              applicationSectionNameList: sectionName,
              applicationSectionFieldList: mappedSectionFields,
              applicationSectionOptionsList: sectionOptions.length ? sectionOptions : [],
              scoringPatternList: scoringPatternList,
              milestoneListAP: milestoneList,
            });
          }
        });
    }
    this.setState({ isAwardProfileModal: true, APOpenMode });
  }
  toggleModalAwardProfileClose() {
    this.setState({
      award_event_profile_id: "",
      award_name: "",
      category_id: "",
      applicantNameSelected: "", type_id: "", categoryNameSelected: '',
      nomination_process_id: "",
      target_applicant_id: "",
      award_type: "", section_label: '',
      is_gst_applicable: '',
      description: "",
      eligibility_criteria: "",
      jury_selection_criteria: "",
      list_of_supporting_elements: "",
      screening_process: "", profile_seq_no: '',
      theme: "", important_instructions: "",
      milestoneListAP: [], milestoneDetailAP: {},
      applicationSectionNameList: [],
      applicationSectionFieldList: [],
      applicationSectionOptionsList: [],
      isAwardProfileModal: false, award_event_profile_declaration: '', award_event_profile_declaration_message: '',
      scoringPatternList: [], scoringPatternDetail: {}, applicationFeeList: [],
      showNewScoringPatternRow: false, scoringPatternDetail: {}, draggingIndexCategory: null, draggingIndexField: null,
      editedScoringPatternRowIndex: null,
      editedScoringPatternRowData: {},
    });
  }
  handleDeleteProfile = (award_event_id, award_event_profile_id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this Award Profile?"
    );
    if (confirmed) {
      this.props
        .awardProfile_delete_action(award_event_id, award_event_profile_id)
        .then((data) => {
          if (data.error !== 1) {
            toast.success("Data Deleted Successfully", {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.getAwardEventDetails();
          } else {
            responseError(data);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };
  onDragEndCategory = (result) => {
    if (!result.destination) return;

    const { source, destination } = result;
    if (source.index === destination.index) return;

    const updatedList = [...this.state.awardCategoryList];
    const [draggedItem] = updatedList.splice(source.index, 1);
    updatedList.splice(destination.index, 0, draggedItem);
    const updatedListWithSeqNo = updatedList.map((item, index) => ({
      ...item,
      seq_no: index + 1,
    }));

    const category_sequence_list = updatedListWithSeqNo.map((item) => ({
      award_event_profile_id: item.award_event_profile_id,
      seq_no: item.seq_no,
    }));

    this.props
      .awardProfile_changeSeq_action(draggedItem.award_event_id, category_sequence_list)
      .then((data) => {
        if (data.error !== 1) {
          this.setState({ awardCategoryList: updatedListWithSeqNo });
          this.getAwardEventDetails(); // Refresh the data
        } else {
          responseError(data); // Handle error
        }
      })
      .catch((e) => {
        console.error("Error updating sequence:", e);
      });
  };
  toggleApplicationSectionModal1Open(award_event_profile_id) {
    this.setState({ isApplicationSectionModal1: true, award_event_profile_id: award_event_profile_id })
  }
  toggleApplicationSectionModal1Close() {
    this.setState({
      isApplicationSectionModal1: false, sectionFieldDetail: {
        award_event_profile_id: ''
      }
    })
  }
  removeField = (section_name, seq_no) => {
    const confirm = window.confirm("are you sure you want to remove this field?")
    if (confirm) {
      const updatedList = this.state.applicationSectionFieldList.filter(
        (field) => field.seq_no !== seq_no || field.section_name !== section_name
      );
      this.setState({ applicationSectionFieldList: updatedList });
    }
  };

  onDragEndField = (result) => {
    const { source, destination } = result;

    // 1. Exit if dropped outside or in the same spot
    if (!destination || (source.index === destination.index && source.droppableId === destination.droppableId)) {
      return;
    }

    // 2. Extract section name from droppableId (e.g., "fields-Firm Details")
    const sectionName = source.droppableId.replace("fields-", "");

    // 3. Get all fields NOT in this section
    const otherSections = this.state.applicationSectionFieldList.filter(
      (f) => f.section_name !== sectionName
    );

    // 4. Get and reorder fields ONLY in this section
    const thisSection = this.state.applicationSectionFieldList
      .filter((f) => f.section_name === sectionName)
      .sort((a, b) => a.seq_no - b.seq_no);

    const [movedItem] = thisSection.splice(source.index, 1);
    thisSection.splice(destination.index, 0, movedItem);

    // 5. Update seq_no for this section only
    const updatedThisSection = thisSection.map((field, index) => ({
      ...field,
      seq_no: index + 1,
    }));

    // 6. Merge back and update state
    this.setState({
      applicationSectionFieldList: [...otherSections, ...updatedThisSection],
    });
  };

  toggleApplicationSectionModal2Open(award_event_profile_id, data, type) {
    this.setState({
      isApplicationSectionModal2: true,
      award_event_profile_id: award_event_profile_id,
      sectionFieldDetail: { award_event_profile_id: award_event_profile_id }
    });

    if (data.length !== 0) {
      const formatsplit = data.file_format ? data.file_format.split(',') : [];
      const matchFormats = formatsplit.map((format) => {
        return this.state.fileFormatFillList.find((fileFormat) => fileFormat.label === format);
      });

      this.setState({
        sectionFieldDetail: {
          award_event_profile_form_section_id: data.award_event_profile_form_section_id != null ? data.award_event_profile_form_section_id : null,
          award_event_profile_section_fields_id: data.award_event_profile_section_fields_id,
          award_event_profile_id: award_event_profile_id,
          section_name: data.section_name,
          fieldname: data.fieldname,
          controltype_id: data.controltype_id,
          file_format: data.file_format,
          max_size: data.max_size,
          seq_no: data.seq_no,
          max_length: data.max_length,
          fileFormats: matchFormats || [],
          is_mandatory: data.is_mandatory == true ? "1" : "0",
          options: data.options || [],
          submitType: type
        }
      });
    }
  }

  toggleApplicationSectionModal2Close() {
    this.setState({
      isApplicationSectionModal2: false, sectionFieldDetail: {
        section_name: '', fieldname: '', controltype_id: '',
        file_format: "", max_size: '', seq_no: null,
        max_length: '', is_mandatory: '', options: [],
        award_event_profile_form_section_id: "",
        award_event_profile_section_fields_id: "",
        submitType: "", fileFormats: []
      }
    })
  }
  //scoring modal
  toggleOptionScoreView(data) {
    if (data.section_fields_id) {
      let finalData;
      if (data.automated_type == 2) {
        finalData = data.tickOptions.map((option) => ({
          scoring_pattern_id: option.award_event_profile_scoring_pattern_id,
          section_fields_id: option.section_fields_id,
          no_of_ticks: option.no_of_ticks,
          score: option.score, max_score: data.max_score,
        }));
        this.setState({ tickOptions: finalData })
      } else if (data.automated_type == 3) {
        finalData = data.options.map((option) => ({
          option: option.options,
          option_id: option.optionsId,
          score_value: option.score_value,
          scoring_pattern_id: option.scoring_pattern_id, max_score: data.max_score,
        }));
        console.log(finalData, 'finalData')
        this.setState({ modalOptionsDetails: finalData })
      } else if (data.automated_type == 4) {
        finalData = data.uploadOptions.map((option) => ({
          scoring_pattern_id: option.award_event_profile_scoring_pattern_id,
          section_fields_id: option.section_fields_id,
          upload_format: option.upload_format,
          score: option.score, max_score: data.max_score,
        }));
        this.setState({ uploadOptions: finalData })
      }
      this.setState({
        isOptionScoreOpen: true,
        isOptionScoreOpenMode: 'view',
        optionsViewType: parseInt(data.automated_type)
      });
    }
  }
  toggleOptionScoreOpen(index, scoringPatternDetail, type) {
    const { applicationSectionFieldList, fileFormatOptionFillList } = this.state;

    if (type === 'new') {
      const award_event_profile_section_fieldsSP =
        applicationSectionFieldList.find(
          (fieldID) => fieldID.award_event_profile_section_fields_id == scoringPatternDetail?.section_fields_id
        )?.award_event_profile_section_fields_id || null;
      const extractedOptions = applicationSectionFieldList
        .filter(
          (data) =>
            data.award_event_profile_section_fields_id ===
            award_event_profile_section_fieldsSP
        )
        .flatMap((filteredData) => filteredData.options || []);
      const extractedOptionsID = applicationSectionFieldList
        .filter(
          (data) =>
            data.award_event_profile_section_fields_id ===
            award_event_profile_section_fieldsSP
        )
        .flatMap((filteredData) => filteredData.optionsId || []);
      let finalData;
      if (parseInt(scoringPatternDetail.automated_type) !== 4) {
        finalData = extractedOptions.map((option, index) => ({
          option: option,
          option_id: extractedOptionsID[index],
          score_value: "",
          max_score: scoringPatternDetail.max_score,
          scoring_pattern_id: option.scoring_pattern_id,
        }))
      } else {
        finalData = fileFormatOptionFillList.map((format) => ({
          upload_format: format.format_type,
          score: "",
          scoring_pattern_id: scoringPatternDetail.scoring_pattern_id,
          max_score: scoringPatternDetail.max_score,
        }));
      }
      if (parseInt(scoringPatternDetail.automated_type) === 4) {
        this.setState({
          isOptionScoreOpen: true,
          isOptionScoreOpenMode: "add",
          uploadOptions: finalData,
          optionsViewType: parseInt(scoringPatternDetail.automated_type),
        });
      } else {
        this.setState({
          isOptionScoreOpen: true,
          isOptionScoreOpenMode: "add",
          modalOptionsDetails: finalData,
          tickOptions: finalData,
          optionsViewType: parseInt(scoringPatternDetail.automated_type),
        });
      }
    } else {
      if (scoringPatternDetail.automated_type == 3) {
        const finalData = scoringPatternDetail.options.map((option) => ({
          option: option.options,
          option_id: option.options_id,
          score_value: option.score_value,
          max_score: scoringPatternDetail.max_score,
          scoring_pattern_id: scoringPatternDetail.scoring_pattern_id,
        }));
        this.setState({
          modalOptionsDetails: finalData,
        });
      } else if (scoringPatternDetail.automated_type == 2) {
        const finalData = scoringPatternDetail.tickOptions.map((option) => ({
          no_of_ticks: option.no_of_ticks,
          section_fields_id: option.section_fields_id,
          score: option.score,
          max_score: scoringPatternDetail.max_score,
          scoring_pattern_id: scoringPatternDetail.scoring_pattern_id,
        }));
        this.setState({
          tickOptions: finalData,
        });
      } else if (scoringPatternDetail.automated_type == 4) {
        const finalData = scoringPatternDetail.uploadOptions.map((format) => ({
          upload_format: format.upload_format,
          score: format.score,
          scoring_pattern_id: scoringPatternDetail.scoring_pattern_id,
          max_score: scoringPatternDetail.max_score,
        }));
        this.setState({
          uploadOptions: finalData,
        });
      }
      this.setState({
        isOptionScoreOpen: true,
        isOptionScoreOpenMode: "add",
        optionsViewType: parseInt(scoringPatternDetail.automated_type),
      });
    }
    // } else {
    //   this.setState({
    //     isOptionScoreOpenMode: "add",
    //     isOptionScoreOpen: true,
    //     modalOptionsDetails: modalOptionsDetails,
    //     optionsViewType: parseInt(scoringPatternDetail.automated_type),
    //   });
    // }
  }

  toggleOptionScoreClose() {
    this.setState({
      isOptionScoreOpenMode: '', isOptionScoreOpen: false, section_fields_id: ' ', max_score: '',
      modalOptionsDetails: [], optionsViewType: null, tickOptions: [], uploadOptions: []

    })
  }
  toggleInstructionDetails() {
    this.setState(prevState => ({
      isInstructionsOpen: !prevState.isInstructionsOpen
    }))
  }
  handleLaunchDateChange = (e) => {
    const newDate = e.target.value;
    this.setState({ launch_date: newDate, launch_dateErr: '' });

    // Call parent function if provided to handle the change
    if (this.props.onDateChange) {
      this.props.onDateChange(newDate);
    }
  };
  validateDates = (e, type) => {
    const { From_date, To_date } = this.state;

    if (type === 1) {
      const newFromDate = e.target.value;
      if (newFromDate && To_date && new Date(newFromDate) > new Date(To_date)) {
        toastError('From date must be before To date.');
        return;
      }
      this.setState({ From_date: newFromDate });
    } else if (type === 2) {
      const newToDate = e.target.value;
      if (From_date && newToDate && new Date(From_date) > new Date(newToDate)) {
        toastError('From date must be before To date.');
        return;
      }
      this.setState({ To_date: newToDate });
    }
  };
  //change
  //pricing 

  handleEditRowPricing = (index, data) => {
    this.setState({
      editedPricingRowIndex: index,
      editedPricingRowData: { ...data },
    });
  };

  cancelEditRowPricing = () => {
    this.setState({
      editedPricingRowIndex: null,
      editedPricingRowData: {},
    });
  };

  saveEditedRowPricing = (index) => {
    const { applicationFeeList, editedPricingRowData } = this.state;
    const { rate_inr, rate_usd } = editedPricingRowData;
    if (!rate_inr) {
      toastError("Please ensure INR Pricing are filled.");
    } else if (!rate_usd) {
      toastError("Please ensure USD Pricing are filled.");
    } else {
      const updatedList = applicationFeeList.map((item, idx) =>
        idx === index ? { ...editedPricingRowData } : item);
      this.setState(
        {
          applicationFeeList: updatedList,
          editedPricingRowIndex: null,
          editedPricingRowData: {},
        }
      );
    }
  };

  handleRowEditFieldChangePricing = (index, field, value) => {
    this.setState((prevState) => {
      const pricingList = Array.isArray(prevState.applicationFeeList)
        ? [...prevState.applicationFeeList]
        : [];

      if (field === 'isSelected') {
        if (pricingList[index]) {
          pricingList[index] = { ...pricingList[index], [field]: value };
          this.setState({ applicationFeeList: pricingList })
        } else {
          toastError(`Row at index ${index} does not exist in pricingList.`);
        }
        return { pricingList };
      } else {
        const updatedRowData = {
          ...prevState.editedPricingRowData,
          [field]: value,
        };
        return { editedPricingRowData: updatedRowData };
      }
    });
  };
  handleApplicationFeeSubmit() {
    const {
      award_event_profile_id,
      applicationFeeList,
      award_event_id
    } = this.state;
    if (applicationFeeList.length === 0) {
      toastError("Kindly select Application Fee");
    }

    for (let fee of applicationFeeList) {
      if (fee.rate_inr === null) {
        toastError(`Please enter rate in INR for ${fee.applicantType}`);
        return;
      }
      if (fee.rate_usd === null) {
        toastError(`Please enter rate in USD for ${fee.applicantType}`);
        return;
      }
    }
    const confirmed = window.confirm(
      `Are you sure you want to ${award_event_profile_id ? "Add" : "Update"} this Award Event?`
    );

    if (confirmed) {
      this.setState({ isLoading: true });

      this.props
        .awardProfileApplicationFee_insertUpdate_action(
          award_event_id,
          award_event_profile_id,
          applicationFeeList
        )
        .then((data) => {
          if (data.error === 0) {
            this.setState({ isLoading: false }, () => {
              toastSuccess(
                award_event_profile_id
                  ? "Award Profile Milestone Updated Successfully"
                  : "Award Profile Milestone Added Successfully"
              );
              this.toggleModalAwardProfileClose();
            });
          } else {
            responseError(data);
          }
        })
        .catch((e) => {
          console.log(e);
          this.setState({ isLoading: false });
          toastError("An unexpected error occurred.");
        });
    }
  }

  //milestone profile AP
  toggleNewMilestoneRowAP = () => {
    this.setState((prevState) => ({
      showNewMilestoneRowAP: !prevState.showNewMilestoneRowAP,
      milestoneDetailAP: {
        isSelected: false,
        milestone_id: '',
        milestone_name: '',
        milestone_date: null,
        is_visible_to_applicant: false,
        stage_name: '',
      },
    }));
  };

  handleMilestoneDetailChangeAP = (field, value) => {
    this.setState((prevState) => ({
      milestoneDetailAP: {
        ...prevState.milestoneDetailAP,
        [field]: value,
      },
    }));
  };
  handleEditMilestoneRowAP = (index, data) => {
    this.setState({
      editedMilestoneRowIndexAP: index,
      editedMilestoneRowDataAP: { ...data },
    });
  };

  cancelEditMilestoneRowAP = () => {
    this.setState({
      editedMilestoneRowIndexAP: null,
      editedMilestoneRowDataAP: {},
    });
  };

  saveEditedMilestoneRowAP = (index) => {
    const { milestoneFillListAP, editedMilestoneRowDataAP } = this.state;
    const { milestone_date, stage_name } = editedMilestoneRowDataAP;
    if (!milestone_date) {
      toastError("Please Ensure Milestone Date are Filled.");
      return;
    } else if (!stage_name) {
      toastError("Please Ensure Stage Name are Filled.");
      return;
    }
    const [day, month, year] = milestone_date.split('-');
    const currentMilestoneDate = new Date(`${year}-${month}-${day}`); // Correctly parse date

    if (isNaN(currentMilestoneDate.getTime())) {
      toastError("Invalid milestone date. Please enter a valid date.");
      return;
    }

    if (index > 0) {
      const previousMilestone = milestoneFillListAP[index - 1];
      const [prevDay, prevMonth, prevYear] = previousMilestone.milestone_date.split('-');
      const previousMilestoneDate = new Date(`${prevYear}-${prevMonth}-${prevDay}`);

      if (isNaN(previousMilestoneDate.getTime())) {
        toastError("Invalid previous milestone date. Please check the data.");
        return;
      }
      // if (currentMilestoneDate <= previousMilestoneDate) {
      //   toastError("Milestone date must be greater than or equal to the previous milestone date.");
      //   return;
      // }
    }

    const formattedDate = `${day}-${month}-${year}`;
    editedMilestoneRowDataAP.milestone_date = formattedDate;
    const updatedList = milestoneFillListAP.map((item, idx) =>
      idx === index ? { ...editedMilestoneRowDataAP, isSelected: true } : item
    );

    this.setState(
      {
        milestoneFillListAP: updatedList,
        editedMilestoneRowIndexAP: null,
        editedMilestoneRowDataAP: {},
      }
    );
  };


  handleMilestoneRowEditFieldChangeAP = (index, field, value, data) => {
    this.setState((prevState) => {
      const milestoneFillList = Array.isArray(prevState.milestoneFillListAP)
        ? [...prevState.milestoneFillListAP]
        : [];

      if (field === 'isSelected') {
        if (milestoneFillList[index]) {
          const updatedMilestone = {
            ...milestoneFillList[index],
            [field]: value,
            stage_name: milestoneFillList[index].milestone_name,
          };
          milestoneFillList[index] = updatedMilestone;
          this.setState({
            milestoneFillListAP: milestoneFillList,
            editedMilestoneRowIndexAP: index,
            editedMilestoneRowDataAP: { ...data, stage_name: data.milestone_name },
          });
        } else {
          toastError(`Row at index ${index} does not exist in milestoneFillList.`);
        }
        return { milestoneFillList };
      } else {
        const updatedRowData = {
          ...prevState.editedMilestoneRowDataAP,
          [field]: value,
        };
        return { editedMilestoneRowDataAP: updatedRowData };
      }
    });
  };

  handleDeleteMilestoneRowAP = (index) => {
    const { milestoneFillListAP } = this.state;
    const updatedList = milestoneFillListAP.filter((_, idx) => idx !== index);

    this.setState({
      milestoneFillListAP: updatedList,
    });
  };
  //milestone event AE
  toggleNewMilestoneRowAE = () => {
    this.setState((prevState) => ({
      showNewMilestoneRowAE: !prevState.showNewMilestoneRowAE,
      milestoneDetailAE: {
        isSelected: false,
        milestone_id: '',
        milestone_name: '',
        milestone_date: null,
        is_visible_to_applicant: false,
        stage_name: '',
      },
    }));
  };

  handleMilestoneDetailChangeAE = (field, value) => {
    this.setState((prevState) => ({
      milestoneDetailAE: {
        ...prevState.milestoneDetailAE,
        [field]: value,
      },
    }));
  };
  handleEditMilestoneRowAE = (index, data) => {
    this.setState({
      editedMilestoneRowIndexAE: index,
      editedMilestoneRowDataAE: { ...data },
    });
  };

  cancelEditMilestoneRowAE = () => {
    this.setState({
      editedMilestoneRowIndexAE: null,
      editedMilestoneRowDataAE: {},
    });
  };

  saveEditedMilestoneRowAE = (index) => {
    const { milestoneFillListAE, editedMilestoneRowDataAE } = this.state;
    let { milestone_date, stage_name } = editedMilestoneRowDataAE;

    // Validate required fields
    if (!milestone_date) {
      toastError("Please ensure Milestone Date is filled.");
      return;
    } else if (!stage_name) {
      toastError("Please ensure Stage Name is filled.");
      return;
    }
    const [day, month, year] = milestone_date.split('-');
    const currentMilestoneDate = new Date(`${year}-${month}-${day}`);
    if (isNaN(currentMilestoneDate.getTime())) {
      toastError("Invalid milestone date. Please enter a valid date.");
      return;
    }
    if (index > 0) {
      const previousMilestone = milestoneFillListAE[index - 1];
      const [prevDay, prevMonth, prevYear] = previousMilestone.milestone_date.split('-');
      const previousMilestoneDate = new Date(`${prevYear}-${prevMonth}-${prevDay}`);
      if (isNaN(previousMilestoneDate.getTime())) {
        toastError("Invalid previous milestone date. Please check the data.");
        return;
      }
      // if (currentMilestoneDate <= previousMilestoneDate) {
      //   toastError("Milestone date must be greater than the previous milestone date.");
      //   return;
      // }
    }
    const formattedDate = `${day}-${month}-${year}`;
    editedMilestoneRowDataAE.milestone_date = formattedDate;

    const updatedList = milestoneFillListAE.map((item, idx) =>
      idx === index ? { ...editedMilestoneRowDataAE, isSelected: true } : item
    );

    this.setState(
      {
        milestoneFillListAE: updatedList,
        editedMilestoneRowIndexAE: null,
        editedMilestoneRowDataAE: {},
      }
    );
  };


  handleMilestoneRowEditFieldChangeAE = (index, field, value, data) => {
    this.setState((prevState) => {
      const milestoneFillList = Array.isArray(prevState.milestoneFillListAE)
        ? [...prevState.milestoneFillListAE]
        : [];

      if (field === 'isSelected') {
        if (milestoneFillList[index]) {
          const updatedMilestone = {
            ...milestoneFillList[index],
            [field]: value, // update the isSelected field
            stage_name: milestoneFillList[index].milestone_name, // set milestone_name to stage_name
          };
          milestoneFillList[index] = updatedMilestone;
          this.setState({
            milestoneFillListAE: milestoneFillList,
            editedMilestoneRowIndexAE: index,
            editedMilestoneRowDataAE: { ...data, stage_name: data.milestone_name }, // Preserve other data while updating
          });
        } else {
          toastError(`Row at index ${index} does not exist in milestoneFillList.`);
        }
        return { milestoneFillList };
      } else {
        const updatedRowData = {
          ...prevState.editedMilestoneRowDataAE,  // Preserve existing data
          [field]: value, // Update the specific field
        };
        return { editedMilestoneRowDataAE: updatedRowData };
      }
    });
  };
  handleDeleteMilestoneRowAE = (index) => {
    const { milestoneFillListAE } = this.state;
    const updatedList = milestoneFillListAE.filter((_, idx) => idx !== index);

    this.setState({
      milestoneFillListAE: updatedList,
    });
  };

  handleAPMilestoneSubmit() {
    const {
      award_event_profile_id,
      milestoneFillListAP, award_event_id
    } = this.state;
    if (milestoneFillListAP.length === 0) {
      toastError("Kindly select milestoneListAE");
    } else {
      const finalMilestoneListAP = milestoneFillListAP
        .filter(item => item.isSelected === true)
        .map(item => {
          let convertedMilestoneDate = item.milestone_date;
          const ddmmyyyyRegex = /^(\d{2})-(\d{2})-(\d{4})$/;
          const yyyymmddRegex = /^\d{4}-\d{2}-\d{2}$/;

          if (ddmmyyyyRegex.test(item.milestone_date)) {
            const [day, month, year] = item.milestone_date.split("-");
            convertedMilestoneDate = `${year}-${month}-${day}`;
          } else if (!yyyymmddRegex.test(item.milestone_date)) {
            toastError(`Invalid date format for milestone ID: ${item.milestone_id}`);
            return null;
          }

          return {
            award_event_id: award_event_id != null ? award_event_id : null,
            milestone_id: item.milestone_id,
            milestone_date: convertedMilestoneDate, // Use the converted date
            is_visible_to_applicant: item.is_visible_to_applicant,
            stage_name: item.stage_name,
          };
        })
        .filter(item => item !== null); // Remove any null entries (invalid date format)

      if (finalMilestoneListAP.length === 0) {
        return; // If no valid milestones left, don't proceed
      }
      const confirmed = window.confirm(
        `Are You sure you want to ${award_event_profile_id ? "Add" : "Update"
        } this Award Event`
      );
      if (confirmed) {
        this.setState({ isLoading: true });
        this.props
          .awardProfileMilestone_insertUpdate_action(
            award_event_profile_id,
            finalMilestoneListAP
          )
          .then((data) => {
            if (data.error === 0) {
              this.setState({ isLoading: false }, () => {
                toastSuccess(
                  award_event_profile_id
                    ? "Award Profile Milestone Updated Successfully"
                    : "Award Profile Milestone Added Successfully"
                );
                setTimeout(() => {
                  this.toggleModalAwardProfileClose();
                  this.getAwardEventDetails(award_event_id)
                }, 1000);
              });
            } else {
              responseError(data);
            }
          })
          .catch((e) => {
            console.log(e);
            this.setState({ isLoading: false });
            toastError("An unexpected error occurred.");
          });
      }
    }
  }
  handleMileStoneMasterSubmit(milestoneMasterMode) {
    const { milestoneDetailAE } = this.state;
    if (
      milestoneDetailAE.milestone_name == "" ||
      milestoneDetailAE.milestone_name == null
    ) {
      toastError("Please enter Milestone Name");
    } else {
      const confirmed = window.confirm(
        `Are You sure you want insert milestone?`
      );
      if (confirmed) {
        this.setState({ isLoading: true });
        this.props
          .insert_milestoneMaster_action(milestoneDetailAE.milestone_name, milestoneMasterMode)
          .then((data) => {
            if (data.error === 0) {
              this.setState({ isLoading: false }, () => {
                toastSuccess("Milestone inserted successfully");
                window.location.reload();
              });
            } else {
              responseError(data);
            }
          })
          .catch((e) => {
            console.log(e);
            this.setState({ isLoading: false });
            toastError("An unexpected error occurred.");
          });
      }
    }
  }
  //scoring pattern
  handleScoreChange = (index, event) => {
    const { modalOptionsDetails } = this.state;
    const newScoreValue = event.target.value;
    const updatedOptions = [...modalOptionsDetails];
    updatedOptions[index].score_value = newScoreValue;

    this.setState({ modalOptionsDetails: updatedOptions });
  };
  submitScoringOptionScore = () => {
    const { modalOptionsDetails, scoringPatternDetail, optionsViewType, tickOptions, uploadOptions } = this.state;
    if (optionsViewType === 2) {
      const submissionData = tickOptions.map(option => ({
        no_of_ticks: parseInt(option.no_of_ticks),
        score: option.score ? parseFloat(option.score) : 0,
        award_event_profile_scoring_pattern_id: option.scoring_pattern_id || null,
      }));
      this.setState(prevState => ({
        scoringPatternDetail: {
          ...prevState.scoringPatternDetail,
          tickOptions: submissionData,
        }, editedScoringPatternRowData: {
          ...prevState.editedScoringPatternRowData,
          tickOptions: submissionData
        },
        isOptionScoreOpen: false, optionsViewType: null
      }));
    } else if (optionsViewType === 3) {
      console.log('hit 1', modalOptionsDetails, scoringPatternDetail)
      const submissionData = modalOptionsDetails.map(option => ({
        option_id: option.option_id || 0,
        options: option.option,
        score_value: option.score_value ? parseFloat(option.score_value) : 0,
      }));
      const updatedOptions = [
        ...(scoringPatternDetail.options || []).filter(
          existingOption =>
            !submissionData.some(newOption => newOption.option_id === existingOption.option_id)
        ),
        ...submissionData
      ];
      console.log('hit 2', updatedOptions, scoringPatternDetail)
      this.setState(prevState => ({
        scoringPatternDetail: {
          ...prevState.scoringPatternDetail,
          options: updatedOptions,
        },
        editedScoringPatternRowData: {
          ...prevState.editedScoringPatternRowData,
          options: updatedOptions
        },
        isOptionScoreOpen: false, optionsViewType: null,

      }));
    } else if (optionsViewType === 4) {
      const submissionData = uploadOptions.map(option => ({
        upload_format: option.upload_format,
        score: (option.score != '' || option.score != null || option.score != undefined) ? parseFloat(option.score) : 0,
        award_event_profile_scoring_pattern_id: option.scoring_pattern_id || null,
      }));
      this.setState(prevState => ({
        scoringPatternDetail: {
          ...prevState.scoringPatternDetail,
          uploadOptions: submissionData,
        }, editedScoringPatternRowData: {
          ...prevState.editedScoringPatternRowData,
          uploadOptions: submissionData
        },
        isOptionScoreOpen: false, optionsViewType: null
      }));
    }
  };

  handleAddRowScoringPattern = () => {
    const { scoringPatternList, scoringPatternDetail, weightage_round1 } = this.state;

    // Validation
    if (!scoringPatternDetail.round_id) {
      toastError("Please Select Round");
      return;
    }
    if (!scoringPatternDetail.scoring_mode_id) {
      toastError("Please Select Scoring Mode");
      return;
    }
    if (!scoringPatternDetail.marking_pattern_name) {
      toastError("Please Enter marking pattern name");
      return;
    }
    if (!scoringPatternDetail.max_score) {
      toastError("Please select Max Score");
      return;
    }
    if (scoringPatternDetail.scoring_mode_id == 1) {
      if (!scoringPatternDetail.automated_type) {
        toastError('Please Select Automated Type')
        return;
      }
    }
    if (parseInt(scoringPatternDetail.automated_type) === 1) {
      if (!scoringPatternDetail.scoring_formula) {
        toastError("Please Enter Scoring Formula");
        return;
      }
    }

    const isDuplicate = scoringPatternList.some(
      (pattern) =>
        pattern.is_active !== 0 &&
        pattern.scoring_mode_id === Number(scoringPatternDetail.scoring_mode_id) &&
        pattern.section_fields_id === Number(scoringPatternDetail.section_fields_id)
    );

    if (isDuplicate) {
      toastError("This combination of Scoring Mode and Section Field already exists.");
      return;
    }

    const currentTotalScore = scoringPatternList.reduce(
      (sum, pattern) => sum + (pattern.is_active !== 0 ? Number(pattern.max_score) || 0 : 0),
      0
    );

    const newMaxScore = Number(scoringPatternDetail.max_score) || 0;
    const updatedTotalScore = currentTotalScore + newMaxScore;

    if (updatedTotalScore > Number(weightage_round1)) {
      toastError(`The total max score cannot exceed ${weightage_round1}.`);
      return;
    }

    const nextTableId =
      scoringPatternList.length > 0
        ? Math.max(0, ...scoringPatternList.map((pattern) => pattern.table_id || 0)) + 1
        : 1;

    const newScoringPattern = {
      table_id: nextTableId,
      scoring_pattern_id: scoringPatternDetail.scoring_pattern_id || null,
      round_id: scoringPatternDetail.round_id,
      scoring_mode_id: Number(scoringPatternDetail.scoring_mode_id),
      section_fields_id: Number(scoringPatternDetail.section_fields_id),
      marking_pattern_name: scoringPatternDetail.marking_pattern_name,
      sp_name: scoringPatternDetail.marking_pattern_name,
      max_score: newMaxScore,
      options: scoringPatternDetail.options,
      tickOptions: scoringPatternDetail.tickOptions,
      uploadOptions: scoringPatternDetail.uploadOptions,
      description: scoringPatternDetail.description,
      scoring_formula: scoringPatternDetail.scoring_formula,
      automated_type: scoringPatternDetail.automated_type,
      is_active: 1,
    };
    console.log(newScoringPattern)
    const confirmed = window.confirm("Are you sure you want to add this scoring pattern?");
    if (confirmed) {
      this.setState((prevState) => {
        const updatedScoringPatternList = [...prevState.scoringPatternList, newScoringPattern];
        const updatedTotalScore = updatedScoringPatternList.reduce(
          (sum, pattern) => sum + (pattern.is_active !== 0 ? Number(pattern.max_score) || 0 : 0),
          0
        );

        const scoreLeft = Math.max(0, weightage_round1 - updatedTotalScore);

        return {
          scoringPatternList: updatedScoringPatternList,
          scoringPatternDetail: {
            scoring_pattern_id: "", round_id: "", scoring_mode_id: "",
            section_fields_id: "", marking_pattern_name: "", sp_name: "",
            max_score: "", options: [], tickOptions: [], uploadOptions: [],
            description: "", scoring_formula: "", automated_type: "",
          },
          showNewScoringPatternRow: false,
          scoreLeft, // Correctly update scoreLeft
          editedScoringPatternRowData: {},
          modalOptionsDetails: [],
          tickOptions: [],
          uploadOptions: [],
        };
      });
    }
  };

  saveEditedScoringPatternRow = () => {
    const { editedScoringPatternRowData, scoringPatternDetail, scoringPatternList, weightage_round1, scoreLeft } = this.state;

    if (!editedScoringPatternRowData.round_id) return toastError("Please Select Round");
    if (!editedScoringPatternRowData.scoring_mode_id) return toastError("Please Select Scoring Mode");
    if (!editedScoringPatternRowData.marking_pattern_name) return toastError("Please Enter Marking Pattern Name");
    if (!editedScoringPatternRowData.max_score) return toastError("Please Enter Max Score");

    const editedMaxScore = Number(editedScoringPatternRowData.max_score);
    if (isNaN(editedMaxScore)) return toastError("Max Score must be a valid number.");

    const existingIndex = scoringPatternList.findIndex((scoring) =>
      scoring.table_id === editedScoringPatternRowData.table_id && scoring.is_active !== 0
    );
    if (existingIndex === -1) return toastError("Edited record not found.");

    const previousMaxScore = Number(scoringPatternList[existingIndex].max_score);
    const scoreDifference = editedMaxScore - previousMaxScore;
    const updatedScoreLeft = scoreLeft - scoreDifference;

    const totalMaxScore = scoringPatternList.reduce(
      (sum, scoring, i) =>
        sum + (i === existingIndex ? editedMaxScore : scoring.is_active !== 0 ? Number(scoring.max_score) : 0),
      0
    );

    if (totalMaxScore > weightage_round1) return toastError(`The total max score cannot exceed ${weightage_round1}.`);
    if (updatedScoreLeft < 0) return toastError("Not enough score left to assign this value.");

    const updatedScoringPatternList = scoringPatternList.map((scoring, i) =>
      i == existingIndex ? {
        ...scoring,
        ...editedScoringPatternRowData,
        options: [...(editedScoringPatternRowData?.options ? editedScoringPatternRowData?.options : scoring?.options ? scoring?.options : [])],
        tickOptions: [...(editedScoringPatternRowData?.tickOptions ? editedScoringPatternRowData?.tickOptions : scoring?.tickOptions ? scoring?.tickOptions : [])],
        uploadOptions: [...(editedScoringPatternRowData?.uploadOptions ? editedScoringPatternRowData?.uploadOptions : scoring?.uploadOptions ? scoring?.uploadOptions : [])],
      } : scoring
    );
    console.log(updatedScoringPatternList, editedScoringPatternRowData, scoringPatternDetail)
    this.setState({
      scoringPatternList: updatedScoringPatternList,
      editedScoringPatternRowIndex: null,
      editedScoringPatternRowData: {},
      scoreLeft: updatedScoreLeft,
      modalOptionsDetails: [], tickOptions: [], uploadOptions: [],
      scoringPatternDetail: {},
    });

    toastSuccess("Record updated successfully.");
  };

  toggleNewScoringPatternRow = () => {
    this.setState({
      editedScoringPatternRowIndex: null,
      editedScoringPatternRowData: {}, scoringPatternDetail: {}, modalOptionsDetails: []
    });
    this.setState((prevState) => ({
      showNewScoringPatternRow: !prevState.showNewScoringPatternRow,
    }));
  };

  handleEditScoringPatternRow = (index, data) => {
    this.setState({
      showNewScoringPatternRow: false,
      editedScoringPatternRowIndex: index,
      editedScoringPatternRowData: { ...data },

    });
  };

  handleScoringPatternRowEditFieldChange = (index, field, value) => {
    this.setState((prevState) => {
      if (field === "isSelected") {
        const updatedscoringPatternList = prevState.scoringPatternList.map((scoring, i) => {
          if (i === index) { return { ...scoring, isSelected: value } }
          return scoring;
        });
        return { scoringPatternList: updatedscoringPatternList, editedScoringPatternRowData: prevState.editedScoringPatternRowData, };
      }
      const updatedEditedData = {
        ...prevState.editedScoringPatternRowData,
        [field]: value,
      };
      return { editedScoringPatternRowIndex: updatedEditedData, };
    });
  };
  cancelEditScoringPatternRow = () => {
    this.setState({
      editedScoringPatternRowIndex: null,
      editedScoringPatternRowData: {},
      modalOptionsDetails: [],
      tickOptions: [], uploadOptions: [],
      scoringPatternDetail: {}
    });
  };

  handleDeleteScoringPatternRow = (data) => {
    const confirmed = window.confirm('Are you sure you want to remove this Scoring Pattern?');
    if (confirmed) {
      this.setState((prevState) => {
        const updatedList = prevState.scoringPatternList.map((row) =>
          row.table_id === data.table_id ? { ...row, is_active: 0 } : row
        );
        return {
          scoringPatternList: updatedList,
          scoreLeft: prevState.scoreLeft + parseInt(data.max_score), // Use prevState.scoreLeft to ensure consistency
        };
      });
    }
  };

  handleScoringPatternChange = (field, value) => {
    this.setState((prevState) => ({
      scoringPatternDetail: {
        ...prevState.scoringPatternDetail,
        [field]: value,
      },
    }));
  };
  handleAPScoringPatternSubmit = () => {
    const { scoringPatternList, award_event_id, award_event_profile_id, weightage_round1, } = this.state;
    if (!scoringPatternList.length) {
      toastError("Kindly select scoringPatternList");
      return;
    }

    const totalMaxScore = scoringPatternList.reduce((sum, pattern) =>
      sum + (pattern.is_active === 1 ? (parseInt(pattern.max_score, 10) || 0) : 0), 0
    );
    if (totalMaxScore !== weightage_round1) {
      toastError(`Total summation of scoring pattern should be equal to ${weightage_round1}`);
      return;
    }

    const actionType = award_event_profile_id ? "Update" : "Add";

    const inactiveSectionFields = scoringPatternList
      .filter((pattern) => pattern.is_active === 0)
      .map((pattern) => pattern.section_fields_id);

    const preparedScoringPatternList = scoringPatternList.map((pattern) => ({
      scoring_pattern_id: pattern.scoring_pattern_id || null,
      award_event_profile_id: award_event_profile_id || null,
      round_id: pattern.round_id,
      scoring_mode_id: pattern.scoring_mode_id,
      section_fields_id: pattern.section_fields_id,
      sp_name: pattern.sp_name,
      max_score: parseInt(pattern.max_score, 10) || 0,
      is_active: pattern.is_active === 1 ? 1 : 0,
      description: pattern.description,
      scoring_formula: pattern.scoring_formula,
      automated_type: pattern.automated_type ? parseInt(pattern.automated_type) : null,
    }));

    const scoringPatternOptionsList = scoringPatternList.flatMap((pattern) =>
      inactiveSectionFields.includes(pattern.section_fields_id)
        ? []
        : (pattern.options || []).map((option) => ({
          award_event_profile_id: award_event_profile_id,
          round_id: pattern.round_id,
          scoring_mode_id: pattern.scoring_mode_id,
          section_fields_id: pattern.section_fields_id,
          options: option.option_id ? option.option_id : option.options_id,
          score_value: option.score_value,
          award_event_profile_scoring_pattern_options_id:
            option.award_event_profile_scoring_pattern_options_id || null,
        }))
    );
    const scoringOptionTicksList = scoringPatternList.flatMap((pattern) =>
      inactiveSectionFields.includes(pattern.section_fields_id)
        ? []
        : (pattern.tickOptions || []).map((option) => ({
          award_event_id: award_event_id,
          award_event_profile_id: award_event_profile_id,
          no_of_ticks: option.no_of_ticks,
          section_fields_id: pattern.section_fields_id,
          score: option.score,
          award_event_profile_scoring_pattern_id: pattern.scoring_pattern_id,
        }))
    );
    console.log(scoringPatternOptionsList, scoringOptionTicksList, scoringPatternList, 'Option')

    const scoringOptionUploadList = scoringPatternList.flatMap((pattern) =>
      inactiveSectionFields.includes(pattern.section_fields_id)
        ? []
        : (pattern.uploadOptions || [])
          .filter((option) => option.score > 0 && option.score != null)
          .map((option) => ({
            award_event_id: award_event_id,
            award_event_profile_id: award_event_profile_id,
            award_event_profile_scoring_pattern_id: pattern.scoring_pattern_id,
            upload_format: option.upload_format,
            score: option.score,
            section_fields_id: pattern.section_fields_id,
          }))
    );

    const confirmed = window.confirm(`Are you sure you want to ${actionType} this Award Event?`);
    if (!confirmed) return;

    this.setState({ isLoading: true });
    this.props
      .insertUpdate_awardProfile_scoringPattern_action(preparedScoringPatternList, scoringPatternOptionsList, scoringOptionTicksList, scoringOptionUploadList)
      .then((data) => {
        if (data.error === 0) {
          toastSuccess(`${actionType} Award Profile Scoring Pattern Successfully`);
          this.setState({ isLoading: false }, () => {
            setTimeout(() => {
              this.setState({ showNewScoringPatternRow: false, scoringPatternDetail: {} });
              this.getAwardEventDetails(award_event_id);
              this.toggleModalAwardProfileClose();
            }, 1000);
          });
        } else {
          responseError(data);
        }
      })
      .catch(() => {
        this.setState({ isLoading: false });
        toastError("An unexpected error occurred.");
      });
  };

  //Award Category
  handleAddRowAwardCategory() {
    const { awardCategoryList, awardCategoryDetail } =
      this.state;

    if (awardCategoryDetail.award_name == "" || awardCategoryDetail.award_name == null) {
      toastError("Please enter Award Name");
    } else {
      const newSDRow = {
        award_event_profile_id: awardCategoryDetail.award_event_profile_id,
        award_name: awardCategoryDetail.award_name,
        is_active: 1,
      };
      this.setState({
        awardCategoryList: [...awardCategoryList, newSDRow],
        awardCategoryDetail: { award_name: "", is_active: 1, },
        showNewAwardCategoryRow: false,
      });
    }
  }
  saveEditedAwardCategoryRow(index) {
    const { awardCategoryList, editedAwardCategoryRowData, } = this.state;
    if (editedAwardCategoryRowData.award_name == "" || editedAwardCategoryRowData.award_name == null) {
      toastError("Please enter award name");
    } else {
      const updatedawardCategoryList = [...awardCategoryList];
      updatedawardCategoryList[index] = editedAwardCategoryRowData;
      this.setState({
        awardCategoryList: updatedawardCategoryList,
        editedAwardCategoryRowIndex: null,
        editedAwardCategoryRowData: {},
        awardCategoryDetail: {
          award_name: "",
        },
      });
    }
  }

  toggleNewAwardCategoryRow() {
    const { milestoneListAE } = this.state;
    this.setState((prevState) => ({
      showNewAwardCategoryRow: !prevState.showNewAwardCategoryRow,
    }));
  }
  handleEditAwardCategoryRow(index, data) {
    this.setState({
      editedAwardCategoryRowIndex: index,
      editedAwardCategoryRowData: { ...data },
    });
  }
  handleAwardCategoryRowEditFieldChange(field, value) {
    const editedDataCopy = { ...this.state.editedAwardCategoryRowData };
    editedDataCopy[field] = value;
    this.setState({ editedAwardCategoryRowData: editedDataCopy });
  }

  cancelEditAwardCategoryRow() {
    this.setState({
      editedAwardCategoryRowIndex: null,
      editedAwardCategoryRowData: {},
    });
  }

  //Jury
  handleInputChangeJury = (index, field, value, award_event_profile_id, jury_id) => {
    const numberPattern = /^[0-9]*$/;
    if (!numberPattern.test(value)) {
      return;
    }

    const updatedDetails = [...this.state.awardEventJuryDetails];

    if (!updatedDetails[index]) {
      updatedDetails[index] = {};
    }

    updatedDetails[index][award_event_profile_id] = {
      ...updatedDetails[index][award_event_profile_id],
      jury_id: jury_id,
      award_event_profile_id: award_event_profile_id,
      [field]: parseInt(value),
      isChecked: value ? true : updatedDetails[index][award_event_profile_id]?.isChecked || false, // Automatically check if value is set
    };

    this.setState({ awardEventJuryDetails: updatedDetails });
  };
  handleSelectAll = (awardEventProfileId, isChecked) => {
    const { juryNameSelected, awardEventJuryDetails } = this.state;
    const updatedDetails = juryNameSelected.map((_, index) => ({
      ...awardEventJuryDetails[index],
      [awardEventProfileId]: { isChecked, factor_value: isChecked ? 1 : null }, // Set factor_value to 1 if checked, null otherwise
    }));

    this.setState({ awardEventJuryDetails: updatedDetails });
  };
  isAllSelected = (awardEventProfileId) => {
    const { juryNameSelected, awardEventJuryDetails } = this.state;
    return juryNameSelected.length > 0 && juryNameSelected.every(
      (_, index) => awardEventJuryDetails[index]?.[awardEventProfileId]?.isChecked
    );
  };

  handleCheckboxChangeJury = (index, checked, award_event_profile_id) => {
    const updatedDetails = [...this.state.awardEventJuryDetails];
    if (!updatedDetails[index]) {
      updatedDetails[index] = {};
    }
    updatedDetails[index][award_event_profile_id] = {
      ...updatedDetails[index][award_event_profile_id],
      isChecked: checked,
      factor_value: 1
    };
    this.setState({ awardEventJuryDetails: updatedDetails });
  };

  handleSubmitJury = async () => {
    const { awardEventJuryDetails, awardCategoryList, award_event_id } = this.state;
    const formattedJuryDetails = Object.fromEntries(
      Object.entries(awardEventJuryDetails).map(([key, jury]) => [
        key, Object.fromEntries(
          Object.entries(jury).map(([subKey, detail]) => [
            subKey, {
              ...detail, jury_id: jury.jury_id || detail.jury_id,
            },
          ])
        ),
      ])
    );
    const juryDataToSubmit = Object.entries(formattedJuryDetails).flatMap(([, jury]) => {
      return Object.entries(jury)
        .filter(([subKey, detail]) => !isNaN(subKey) && detail.isChecked && detail.jury_id)
        .map(([subKey, detail]) => ({
          jury_id: detail.jury_id,
          award_event_profile_id: parseInt(subKey, 10),
          factor_value: detail.factor_value,
        }));
    });
    const enrichedJuryData = juryDataToSubmit
      .map((juryData) => {
        const awardCategory = awardCategoryList.find(
          (category) => category.award_event_profile_id === juryData.award_event_profile_id
        );
        return {
          jury_id: juryData.jury_id,
          award_name: awardCategory ? awardCategory.award_name : null,
          factor_value: juryData.factor_value,
        };
      })
      .filter((item) => item.award_name);
    const isValid = enrichedJuryData.some(
      (item) => item.factor_value !== null && item.factor_value !== undefined
    );

    if (!isValid) {
      toastError("Kindly enter a valid jury factor");
      return;
    }
    const confirm = window.confirm('Are you sure you want to Submit this Jury?')
    if (confirm) {
      this.setState({ isLoading: true });
      try {
        const data = await this.props.awardEventJury_insertUpdate_action(
          award_event_id,
          enrichedJuryData
        );
        this.setState({ isLoading: false });

        if (data.error !== 1) {
          toastSuccess("Data Submitted Successfully");
          this.getAwardEventDetails(award_event_id);
        } else {
          responseError(data);
        }
      } catch (e) {
        console.error("Submission error:", e);
        this.setState({ isLoading: false });
      }
    }
  };
  handleDeleteRowJury(index) {
    const { juryNameSelected, awardEventJuryDetails } = this.state;
    const confirm = window.confirm('Are you sure you want to remove this record?');
    if (confirm) {
      const juryToDelete = juryNameSelected[index];
      const updatedJuryList = juryNameSelected.filter((_, rowIndex) => rowIndex !== index);
      const updatedAwardEventJuryDetails = awardEventJuryDetails.filter(jury => jury.jury_id !== juryToDelete.value);
      this.setState({
        juryNameSelected: updatedJuryList,
        awardEventJuryDetails: updatedAwardEventJuryDetails,
      });
    }
  }
  //dependency
  navigateBackAwardEventList() {
    this.props.navigate("/awardEvent");
  }
  clearFields() {
    this.setState({
      award_event_id: "",
      Event_Name: this.props.location.state.Event_Name,
      Name: "",
    });
  }
  inputValidate() {
    const { Event_Name, From_date, To_date, launch_date, award_address, award_state, award_country, weightage_round1 } = this.state;
    let isValid = true;
    this.setState({ Event_NameErr: '', From_dateErr: '', launch_dateErr: '', To_dateErr: '', award_addressErr: '', award_stateErr: '', award_countryErr: '', weightage_round1Err: '' })
    if (Event_Name == "" || Event_Name == null) {
      this.setState({ Event_NameErr: "Please enter Award Name" });
      isValid = false;
    }
    if (From_date == "" || From_date == null) {
      this.setState({ From_dateErr: "Please Select From Date" });
      isValid = false;
    }
    if (To_date == "" || To_date == null) {
      this.setState({ To_dateErr: "Please Select To Date" });
      isValid = false;
    } if (launch_date == "" || launch_date == null) {
      this.setState({ launch_dateErr: "Please Select To Date" });
      isValid = false;
    }
    if (award_address == "" || award_address == null) {
      this.setState({ award_addressErr: "Please enter Award Address" });
      isValid = false;
    }
    if (award_state == "" || award_state == null) {
      this.setState({ award_stateErr: "Please Select Award State" });
      isValid = false;
    }
    if (award_country == "" || award_country == null) {
      this.setState({ award_countryErr: "Please Select Award Country" });
      isValid = false;
    } if (weightage_round1 == "" || weightage_round1 == null) {
      this.setState({ weightage_round1Err: "Please Enter Weightage for Round 1" });
      isValid = false;
    }
    return isValid
  }

  //crud
  handleSubmit() {
    const { award_event_id, Event_Name, Event_Description, From_date, To_date, launch_date, award_address, award_state, award_country, milestoneFillListAE, weightage_round1, weightage_round2 } = this.state;
    const isValid = this.inputValidate();
    if (isValid === true) {
      if (milestoneFillListAE.length === 0) {
        toastError("Kindly select milestoneListAE");
      } else {
        const finalMilestoneListAE = milestoneFillListAE
          .filter(item => item.isSelected === true)
          .map(item => {
            let convertedMilestoneDate = item.milestone_date;
            const ddmmyyyyRegex = /^(\d{2})-(\d{2})-(\d{4})$/;
            const yyyymmddRegex = /^\d{4}-\d{2}-\d{2}$/;

            if (ddmmyyyyRegex.test(item.milestone_date)) {
              const [day, month, year] = item.milestone_date.split("-");
              convertedMilestoneDate = `${year}-${month}-${day}`;
            } else if (!yyyymmddRegex.test(item.milestone_date)) {
              toastError(`Invalid date format for milestone ID: ${item.milestone_id}`);
              return null;
            }

            return {
              award_event_id: award_event_id != null ? award_event_id : null,
              milestone_id: item.milestone_id,
              milestone_date: convertedMilestoneDate,
              is_visible_to_applicant: item.is_visible_to_applicant,
              stage_name: item.stage_name,
            };
          })
          .filter(item => item !== null);

        if (finalMilestoneListAE.length === 0) {
          return;
        }
        const confirmed = window.confirm(
          `Are You sure you want to ${award_event_id ? "Add" : "Update"} this Award Event`
        );
        if (confirmed) {
          this.setState({ isLoading: true });
          this.props
            .awardEventMilestone_insertUpdate_action(
              award_event_id, Event_Name, From_date, To_date, launch_date, award_address,
              parseInt(award_state), parseInt(award_country), Event_Description,
              finalMilestoneListAE, weightage_round1, weightage_round2
            )
            .then((data) => {
              if (data.error === 0) {
                this.setState({ isLoading: false }, () => {
                  toastSuccess(
                    award_event_id
                      ? "Award Event Updated Successfully"
                      : "Award Event Added Successfully"
                  );
                  setTimeout(() => {
                    this.props.navigate("/awardEvent");
                  }, 1000);
                });
              } else {
                responseError(data);
              }
            })
            .catch((e) => {
              console.log(e);
              this.setState({ isLoading: false });
              toastError("An unexpected error occurred.");
            });
        }
      }
    }
  }

  inputValidateAwardProfile() {
    const { award_name, categoryNameSelected, applicantNameSelected,
      award_type, nomination_process_id, section_label
    } = this.state;

    let isValid = true;
    // Clear all errors initially
    this.setState({
      award_nameErr: '', section_labelErr: '',
      category_idErr: '',
      applicant_type_idErr: '',
      award_typeErr: '',
      nomination_process_idErr: '',
    });

    if (!award_name) {
      this.setState({ award_nameErr: "Please enter Award name" });
      isValid = false;
    }
    if (!section_label) {
      this.setState({ section_labelErr: "Please enter Section Label" });
      isValid = false;
    }
    if (!categoryNameSelected || categoryNameSelected == [] || categoryNameSelected.length === 0) {
      this.setState({ category_idErr: "Please select Category Type" });
      isValid = false;
    }
    if (!applicantNameSelected || applicantNameSelected == [] || applicantNameSelected.length === 0) {
      this.setState({ applicant_type_idErr: "Please select Application Type" });
      isValid = false;
    }
    if (!award_type) {
      this.setState({ award_typeErr: "Please select Type" });
      isValid = false;
    }
    if (!nomination_process_id || nomination_process_id === "Select") {
      this.setState({ nomination_process_idErr: "Please select Nomination Process" });
      isValid = false;
    }
    return isValid;
  }
  handleAwardProfileSubmit() {
    const { award_event_profile_id, award_event_id, award_name, categoryNameSelected, applicantNameSelected,
      is_gst_applicable, target_applicant_id, award_type, nomination_process_id, description,
      eligibility_criteria, screening_process, jury_selection_criteria, list_of_supporting_elements,
      theme, important_instructions, profile_seq_no, awardCategoryList, section_label
    } = this.state;

    const isValid = this.inputValidateAwardProfile();
    if (!isValid) {
      toastError("Please enter all mandatory fields");
      return;
    } else {
      const applicantTypeList = applicantNameSelected?.map((data) => ({
        applicant_type_id: data.value,
      }));

      // Convert categoryNameSelected to a comma-separated string
      const category_id = categoryNameSelected
        .map((category) => category.value)
        .join(",");
      const final_seq_no = award_event_profile_id
        ? profile_seq_no
        : (awardCategoryList.length > 0 && awardCategoryList.length + 1);
      console.log(final_seq_no, profile_seq_no, 'final_seq_no')
      const confirmed = window.confirm(
        `Are You sure you want ${award_event_profile_id ? "update" : "insert"} Award Profile?`
      );
      if (confirmed) {
        this.setState({ isLoading: true });
        this.props
          .insertUpdate_awardProfile_action(
            award_event_profile_id, award_event_id, award_name, category_id,
            applicantTypeList, target_applicant_id, award_type,
            nomination_process_id, is_gst_applicable, description,
            eligibility_criteria, screening_process, jury_selection_criteria,
            list_of_supporting_elements, theme, important_instructions, 1, final_seq_no, section_label
          )
          .then((data) => {
            if (data.error === 0) {
              toastSuccess("Award Profile Submitted successfully");
              this.setState({ isLoading: false }, () => {
                setTimeout(() => {
                  this.toggleModalAwardProfileClose();
                  this.getAwardEventDetails(award_event_id);
                }, 2000);
              });
            } else {
              responseError(data);
            }
          })
          .catch((e) => {
            console.log(e);
            this.setState({ isLoading: false });
            toastError("An unexpected error occurred.");
          });
      }
    }
  }

  handleAwardProfileApplicationSubmit() {
    const {
      applicationSectionFieldList, applicationSectionNameList, award_event_profile_id,
      award_event_profile_declaration, award_event_profile_declaration_message,
      award_event_id } = this.state;
    const finalSectionNameList = applicationSectionNameList.map((item) => ({
      award_event_profile_section_id: item.award_event_profile_form_section_id != null ? item.award_event_profile_form_section_id : null,
      award_event_profile_id: item.award_event_profile_id,
      section_name: item.section_name,
      seq_no: item.seq_no,
      is_active: 1
    }));

    const finalSectionFieldList = applicationSectionFieldList.map((item) => ({
      award_event_profile_section_fields_id: item.award_event_profile_section_fields_id != null ? item.award_event_profile_section_fields_id : null,
      award_event_profile_form_section_id: item.award_event_profile_form_section_id != null ? item.award_event_profile_form_section_id : null,
      fieldname: item.fieldname,
      seq_no: item.seq_no,
      controltype_id: item.controltype_id,
      is_mandatory: item.is_mandatory == 1 ? 1 : 0,
      max_length: item.max_length != null ? item.max_length : null,
      max_size: item.max_size != null ? item.max_size : null,
      file_format: item.file_format != null ? item.file_format : null,
      section_name: item.section_name
    }));

    // Prepare finalSectionOptionList
    const finalSectionOptionList = applicationSectionFieldList.flatMap((item) => {
      if (Array.isArray(item.options)) {
        return item.options.map(option => ({
          award_event_profile_section_fields_options_id: item.award_event_profile_section_fields_options_id != null ? item.award_event_profile_section_fields_options_id : null,
          award_event_profile_section_fields_id: item.award_event_profile_section_fields_id != null ? item.award_event_profile_section_fields_id : null,
          options: option,
          fieldname: item.fieldname,
          section_name: item.section_name
        }));
      }
      return [];
    });

    // Validation: Check if any section_name exists without fields
    const sectionNamesWithoutFields = applicationSectionNameList.filter(section => {
      return !applicationSectionFieldList.some(field => field.section_name === section.section_name);
    });

    if (sectionNamesWithoutFields.length > 0) {
      toastError(`Fields are missing for section: ${sectionNamesWithoutFields.map(s => s.section_name).join(', ')}`);
      return; // Block submission
    }

    // Check other conditions
    if (finalSectionFieldList.length === 0) {
      toastError('Kindly Enter Fields');
    } else if (award_event_profile_declaration === '' || award_event_profile_declaration === null || award_event_profile_declaration === undefined || award_event_profile_declaration === '<p><br></p>') {
      toastError('Kindly fill declaration');
    } else {
      const confirmed = window.confirm(
        `Are you sure you want to submit this Application Form Sections?`
      );
      if (confirmed) {
        this.setState({ isLoading: true });

        this.props.insertUpdate_awardProfile_applicationSection_action({
          award_event_profile_id,
          award_event_profile_declaration, award_event_profile_declaration_message,
          applicationSectionNameList: finalSectionNameList,
          applicationSectionFieldList: finalSectionFieldList,
          applicationSectionOptionsList: finalSectionOptionList
        }).then((data) => {
          this.setState({ isLoading: false });

          if (data.error === 0) {
            this.toggleModalAwardProfileClose();
            toastSuccess("Application Form Submitted Successfully");
            this.getAwardEventDetails(award_event_id);
          } else {
            toastError(data.msg || "An error occurred while submitting the form");
          }
        }).catch(() => {
          this.setState({ isLoading: false });
          toastError("An unexpected error occurred");
        });
      }
    }
  }

  toggleSectionName = (index) => {
    this.setState(prevState => ({
      isSectionEdit: prevState.isSectionEdit === index ? null : index
    }));
  }
  handleSectionNameChange = (e, index) => {
    const newSectionName = e.target.value.trim(); // Remove leading/trailing spaces
    const updatedSections = [...this.state.applicationSectionNameList];
    const oldSectionName = updatedSections[index].section_name;

    // Check if the new name already exists in the list (excluding the current section)
    const nameExists = updatedSections.some(
      (section, i) => i !== index && section.section_name.toLowerCase() === newSectionName.toLowerCase()
    );

    if (nameExists) {
      alert("Section name already exists! Please choose a different name."); // Or set an error state
      return;
    }

    updatedSections[index].section_name = newSectionName;

    // Update section names in related lists
    const updatedFieldList = this.state.applicationSectionFieldList.map((field) =>
      field.section_name === oldSectionName ? { ...field, section_name: newSectionName } : field
    );

    const updatedOptionsList = this.state.applicationSectionOptionsList.map((option) =>
      option.section_name === oldSectionName ? { ...option, section_name: newSectionName } : option
    );

    this.setState({
      applicationSectionNameList: updatedSections,
      applicationSectionFieldList: updatedFieldList,
      applicationSectionOptionsList: updatedOptionsList,
    });
  };


  addSection = () => {
    const { award_event_profile_id } = this.state;
    const newSectionIndex = this.state.applicationSectionNameList.length + 1;

    this.setState(prevState => ({
      applicationSectionNameList: [
        ...prevState.applicationSectionNameList,
        { section_name: `Section ${newSectionIndex}`, seq_no: newSectionIndex, award_event_profile_id: award_event_profile_id, is_active: 1 } // Ensure you're adding the necessary ID if required
      ]
    }));
  }
  removeSection = (index, section_name) => {
    const confirm = window.confirm("are you sure you want to remove this section?")
    if (confirm) {
      const updatedFieldList = this.state.applicationSectionFieldList.filter((field) => field.section_name !== section_name)
      this.setState(prevState => ({
        applicationSectionNameList: prevState.applicationSectionNameList.filter((_, i) => i !== index),
        applicationSectionFieldList: updatedFieldList
      }));
    }
  }

  saveApplicationSection = () => {
    const { sectionFieldDetail, applicationSectionOptionsList } = this.state;
    const newSectionDetail = {
      ...sectionFieldDetail,
      options: sectionFieldDetail.options.join(", ") // Convert array to string if needed
    };

    this.setState({
      applicationSectionOptionsList: [
        ...applicationSectionOptionsList,
        newSectionDetail
      ]
    });

  }
  addOption = () => {
    const { sectionFieldDetail } = this.state;
    const { newOption } = sectionFieldDetail;
    if (sectionFieldDetail.newOption == '') {
      toastError('Kindly Enter Option')
    } else {
      const currentOptions = sectionFieldDetail.options || [];
      if (newOption.trim()) {
        this.setState({
          sectionFieldDetail: {
            ...sectionFieldDetail,
            options: [...currentOptions, newOption.trim()],
            newOption: ''
          }
        })
      }
    }
  }

  editOption = (index, option) => {
    this.setState({
      editingOptionIndex: index,
      editingOptionText: option,
    });
  };
  saveOption = (index) => {
    this.setState((prevState) => {
      const updatedOptions = [...prevState.sectionFieldDetail.options];
      updatedOptions[index] = prevState.editingOptionText;

      return {
        sectionFieldDetail: {
          ...prevState.sectionFieldDetail,
          options: updatedOptions,
        },
        editingOptionIndex: null,
        editingOptionText: '',
      };
    });
  };


  updateOption = (index) => {
    const updatedOptions = [...this.state.sectionFieldDetail.options];
    updatedOptions[index] = this.state.editingOptionText;

    this.setState({
      sectionFieldDetail: {
        ...this.state.sectionFieldDetail,
        options: updatedOptions,
      },
      editingOptionIndex: null,
      editingOptionText: "",
    });
  };

  cancelEdit = () => {
    this.setState({
      editingOptionIndex: null,
      editingOptionText: "",
    });
  };

  removeOption = (index) => {
    const confirm = window.confirm("are you sure you want to remove this option?")
    if (confirm) {
      const updatedOptions = this.state.sectionFieldDetail.options.filter(
        (_, i) => i !== index
      );

      this.setState({
        sectionFieldDetail: {
          ...this.state.sectionFieldDetail,
          options: updatedOptions,
        },
      });
    }
  };
  renderDynamicFields = () => {
    const { controlTypeAPFillList, fileFormatFillList } = this.state
    const { controltype_id } = this.state.sectionFieldDetail;
    const sectionType = controlTypeAPFillList.find(
      (item) => item.controltype_id === parseInt(controltype_id, 10)
    );

    if (!sectionType) return null;

    switch (sectionType.controltype) {
      case "File Upload":
        return (
          <>
            <div className="form-group">
              <label htmlFor="file_format">
                File Format <span className="mendatory_class">*</span>
              </label>
              <Select
                isMulti
                value={this.state.sectionFieldDetail.fileFormats}
                options={fileFormatFillList}
                styles={customStyles}
                onChange={this.handleFileFormatChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="max_size">
                Max File Size (in mb) <span className="mendatory_class">*</span>
              </label>
              <input
                type="text"
                name="max_size"
                value={this.state.sectionFieldDetail.max_size}
                className="form-control border-input"
                placeholder="File size in mb"
                onChange={this.handleNumericInputChange}
              />
            </div>
          </>
        );

      case "Dropdown - Single-Select":
      case "Dropdown - Multi-Select":
      case "Checkbox - Single-Select":
      case "Checkbox - Multi-Select":
        return this.renderOptionsField();

      case "Date Picker":
      case "Note":
        return null;

      default:
        return (
          <div className="form-group">
            <label htmlFor="max_length">
              Max Length <span className="mendatory_class">*</span>
            </label>
            <input
              type="text"
              name="max_length"
              value={this.state.sectionFieldDetail.max_length}
              className="form-control border-input"
              placeholder="Enter max length"
              onChange={this.handleFieldDetailChange}
            />
          </div>
        );
    }
  };
  renderOptionsField = () => {
    const { options, newOption } = this.state.sectionFieldDetail;

    return (
      <div className="form-group">
        <label htmlFor="options">
          Options <span className="mendatory_class">*</span>
        </label>
        <div className="d-flex align-items-center">
          <input
            type="text"
            name="newOption"
            value={newOption}
            className="form-control border-input mr-2"
            placeholder="Enter option"
            onChange={this.handleFieldDetailChange}
          />
          <a title="Add Option" onClick={this.addOption}>
            <i className="ri-add-line"></i>
          </a>
        </div>
        <ul className="mt-3">
          {options?.length ? (
            options.map((option, index) => this.renderOptionItem(option, index))
          ) : (
            <li>No options added yet.</li>
          )}
        </ul>

      </div>
    );
  };
  renderOptionItem(option, index) {
    const { editingOptionIndex, editingOptionText } = this.state;

    return (
      <li key={index} className="d-flex align-items-center mb-2">
        {editingOptionIndex === index ? (
          <>
            <input
              type="text"
              value={editingOptionText}
              onChange={(e) => this.setState({ editingOptionText: e.target.value })}
              className="form-control mr-2"
            />
            <a title="Save Option" onClick={() => this.saveOption(index)}>
              <i className="fa fa-check text-success mr-1"></i>
            </a>
            <a title="Cancel Edit" onClick={() => this.setState({ editingOptionIndex: null })}>
              <i className="fa fa-times text-danger"></i>
            </a>
          </>
        ) : (
          <>
            <span className="mr-2">{index + 1}. {option}</span>
            <a title="Edit Option" onClick={() => this.editOption(index, option)}>
              <i className="fa fa-pencil-square-o text-primary mr-1"></i>
            </a>
            <a title="Remove Option" onClick={() => this.removeOption(index)}>
              <i className="ri-delete-bin-line text-danger"></i>
            </a>
          </>
        )}
      </li>
    );
  }

  handleFieldDetailChange = ({ target: { name, value } }) => {
    const sectionFieldDetail = { ...this.state.sectionFieldDetail };
    sectionFieldDetail[name] = value;
    this.setState({ sectionFieldDetail });
  };


  handleNumericInputChange = (e) => {
    const { name, value } = e.target;
    if (/^\d*$/.test(value)) {
      this.setState((prevState) => ({
        sectionFieldDetail: {
          ...prevState.sectionFieldDetail,
          [name]: value,
        },
      }));
    } else {
      toast.error("Only numeric values are allowed.");
    }
  };

  handleFileFormatChange = (selectedOptions) => {
    const fileFormatString = selectedOptions.map((option) => option.label).join(",");
    this.setState((prevState) => ({
      sectionFieldDetail: {
        ...prevState.sectionFieldDetail,
        file_format: fileFormatString,
        fileFormats: selectedOptions,
      },
    }));
  };

  togglePublish(publishSubmitType) {
    const { publishView } = this.state
    this.setState({ publishView: !publishView, publishSubmitType: publishSubmitType })
  }
  publishForm(award_event_id, award_event_profile_id, publish_status) {
    const { scoringPatternList, applicationFeeList } = this.state;
    if (publish_status === 1) {
      if (applicationFeeList && applicationFeeList.length > 0) {
        const hasInvalidFees = applicationFeeList.some(fee => fee.rate_inr === null || fee.rate_usd === null);
        if (hasInvalidFees) {
          toastError(`Kindly Fill Application Fee to Publish`);
          return;
        }
      }
      if (!scoringPatternList || scoringPatternList.length === 0) {
        toastError(`Kindly Fill Scoring Pattern to Publish`);
        return; // Exit if scoringPatternList is empty
      }
    }
    this.props
      .awardProfile_formPublish_action(award_event_id, award_event_profile_id, publish_status)
      .then((data) => {
        if (data.error !== 1) {
          toast.success(publish_status ? `Award Category Published Successfully` : 'Award Category Publish Revoked Successfully', {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          this.getAwardEventDetails();
          this.setState({ publishView: false });
          this.toggleModalAwardProfileClose();
        } else {
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  SubmitSectionModal2() {
    const { sectionFieldDetail, controlTypeAPFillList, applicationSectionFieldList } = this.state;

    if (!sectionFieldDetail.section_name) {
      toastError("Kindly enter section");
      return;
    }
    if (!sectionFieldDetail.fieldname) {
      toastError("Please enter field name");
      return;
    }
    if (!sectionFieldDetail.controltype_id || sectionFieldDetail.controltype_id === "select") {
      toastError("Kindly select Control Type");
      return;
    }

    // Check if fieldname already exists in the given section_name (excluding the current field if updating)
    const isDuplicateFieldname = applicationSectionFieldList.some(
      (field) =>
        field.section_name === sectionFieldDetail.section_name &&
        field.fieldname.toLowerCase() === sectionFieldDetail.fieldname.toLowerCase() &&
        !(sectionFieldDetail.submitType === "update" && field.seq_no === sectionFieldDetail.seq_no)
    );

    if (isDuplicateFieldname) {
      toastError("Field name already exists in this section. Please use a different name.");
      return;
    }

    const sectionType = controlTypeAPFillList.find(
      (item) => item.controltype_id === parseInt(sectionFieldDetail.controltype_id)
    );

    if (sectionType) {
      if (sectionType.controltype === "File Upload") {
        if (!sectionFieldDetail.file_format) {
          toastError("Please select file format");
          return;
        }
        if (!sectionFieldDetail.max_size) {
          toastError("Please enter Max File Size");
          return;
        }
      } else if (
        ["Dropdown - Single-Select", "Dropdown - Multi-Select", "Checkbox - Single-Select", "Checkbox - Multi-Select"].includes(sectionType.controltype)
      ) {
        if (sectionFieldDetail.options.length === 0) {
          toastError("Please select options");
          return;
        }
      } else if (
        [
          "Text Box - Numeric",
          "Text Box - Decimal",
          "Text Box - AlphaNumeric",
          "Multiline Text Box",
          "Text Box - Website",
          "Text Box - Phone Number",
          "Text Box - Email"
        ].includes(sectionType.controltype)
      ) {
        if (!sectionFieldDetail.max_length) {
          toastError("Please enter max length");
          return;
        }
      }
    }

    if (sectionType.controltype !== "Note") {
      if (!sectionFieldDetail.is_mandatory || sectionFieldDetail.is_mandatory === "select") {
        toastError("Please select Is Mandatory field");
        return;
      }
    }

    if (sectionFieldDetail.submitType === "add") {
      let newseq_no = applicationSectionFieldList.length
        ? Math.max(...applicationSectionFieldList.map((item) => parseInt(item.seq_no) || 0)) + 1
        : 1;

      const NewapplicationSectionFieldList = {
        award_event_profile_form_section_id: sectionFieldDetail.award_event_profile_form_section_id || null,
        award_event_profile_section_fields_id: sectionFieldDetail.award_event_profile_section_fields_id || null,
        award_event_profile_id: parseInt(sectionFieldDetail.award_event_profile_id),
        section_name: sectionFieldDetail.section_name,
        fieldname: sectionFieldDetail.fieldname,
        is_mandatory: sectionFieldDetail.is_mandatory || 0,
        controltype_id: sectionFieldDetail.controltype_id,
        file_format: sectionFieldDetail.file_format || "",
        max_size: sectionFieldDetail.max_size || "",
        max_length: sectionFieldDetail.max_length || "",
        options: sectionFieldDetail.options || [],
        fileFormats: sectionFieldDetail.fileFormats || [],
        seq_no: parseInt(newseq_no),
      };

      this.setState((prevState) => ({
        applicationSectionFieldList: [...prevState.applicationSectionFieldList, NewapplicationSectionFieldList],
        sectionFieldDetail: {
          award_event_profile_form_section_id: "",
          award_event_profile_section_fields_id: "",
          section_name: "",
          fieldname: "",
          controltype_id: "",
          file_format: "",
          max_size: "",
          max_length: "",
          is_mandatory: "",
          seq_no: null,
          options: [],
          fileFormats: [],
        },
        isApplicationSectionModal2: false,
      }));
    } else if (sectionFieldDetail.submitType === "update") {
      const updatedList = applicationSectionFieldList.map((item) =>
        item.seq_no === sectionFieldDetail.seq_no && item.section_name === sectionFieldDetail.section_name
          ? {
            ...item,
            fieldname: sectionFieldDetail.fieldname,
            is_mandatory: sectionFieldDetail.is_mandatory,
            controltype_id: sectionFieldDetail.controltype_id,
            file_format: sectionFieldDetail.file_format,
            max_size: sectionFieldDetail.max_size,
            max_length: sectionFieldDetail.max_length,
            options: sectionFieldDetail.options,
            fileFormats: sectionFieldDetail.fileFormats,
          }
          : item
      );

      this.setState({
        applicationSectionFieldList: updatedList,
        sectionFieldDetail: {
          award_event_profile_form_section_id: "",
          award_event_profile_section_fields_id: "",
          section_name: "",
          fieldname: "",
          controltype_id: "",
          file_format: "",
          max_size: "",
          max_length: "",
          is_mandatory: "",
          seq_no: null,
          options: [],
          fileFormats: [],
        },
        isApplicationSectionModal2: false,
      });
    }
  }

  //ticks options modal
  addRowTickOptions = () => {
    const { tickOptions } = this.state;
    const lastRow = tickOptions[tickOptions.length - 1];
    if (!lastRow?.no_of_ticks || !lastRow?.score) {
      toastError("Please fill out the current row before adding a new one.");
      return;
    }
    this.setState({
      tickOptions: [...tickOptions, { no_of_ticks: "", score: "" }],
    });
  };

  removeRowTickOptions = (index) => {
    const { tickOptions } = this.state;
    const removedRow = tickOptions[index];
    this.setState({
      tickOptions: tickOptions.filter((_, i) => i !== index),
      usedNumbers: this.state.usedNumbers.filter((num) => num !== removedRow.selected),
    });
  };
  handleSelectChangeTickOptions = (selectedValue, index) => {
    const { tickOptions } = this.state;
    const usedNumbers = tickOptions.map((option) => option.no_of_ticks);
    if (usedNumbers.includes(selectedValue) && tickOptions[index].no_of_ticks !== selectedValue) {
      toastError(`The number ${selectedValue} has already been selected. Please choose another.`);
      return;
    }

    // Update the selected value
    const updatedOptions = [...tickOptions];
    updatedOptions[index].no_of_ticks = selectedValue;
    this.setState({ tickOptions: updatedOptions });
  };


  handleInputChangeTickOptions = (value, index) => {
    const { tickOptions } = this.state;
    const updatedOptions = tickOptions.map((row, i) =>
      i === index ? { ...row, score: value } : row
    );
    this.setState({ tickOptions: updatedOptions });
  };


  render() {
    const { publishView, categoryNameSelected, weightage_round1, weightage_round1Err, weightage_round2, weightage_round1Note,
      isAwardProfileModal, isApplicationSectionModal1, isApplicationSectionModal2, isInstructionsOpen,
      isLoading, APOpenMode, applicationSectionNameList, publishSubmitType, launch_date, launch_dateErr,
      award_event_id, Event_Name, Event_Description, From_date, award_address, award_country, award_state,
      Event_NameErr, From_dateErr, To_dateErr, award_addressErr, award_countryErr, award_stateErr,
      To_date, juryNameSelected, applicantNameSelected, showNewMilestoneRowAE, milestoneDetailAE,
      is_active, awardCategoryList, juryNameFill, milestoneFillListAE,
      scoringModeFillList, mandatoryAPFillList, controlTypeAPFillList, isOptionScoreOpenMode,
      scoringRoundFillList, countryFillList, stateFillList, editedPricingRowIndex, editedPricingRowData, applicationFeeList,
      //award profile
      award_event_profile_id, award_name, award_nameErr, category_idErr, section_labelErr, section_label,
      applicant_type_idErr, publish_status, award_type, award_typeErr, nomination_process_id, nomination_process_idErr,
      description, descriptionErr, eligibility_criteria, eligibility_criteriaErr,
      screening_process, screening_processErr, jury_selection_criteria, jury_selection_criteriaErr, list_of_supporting_elementsErr,
      list_of_supporting_elements, categoryFillList, applicantTypeFillList, nominationProcessFillList, automatedTypeFillList
      , theme, themeErr, category_names, important_instructions, important_instructionsErr, is_gst_applicable, is_gst_applicableErr,
      //scoring pattern
      scoringPatternDetail, scoringPatternList, editedScoringPatternRowData, editedScoringPatternRowIndex, showNewScoringPatternRow,
      editedMilestoneRowIndexAE, editedMilestoneRowDataAE, applicationSectionFieldList,
      milestoneFillListAP, editedMilestoneRowDataAP, editedMilestoneRowIndexAP, showNewMilestoneRowAP, milestoneDetailAP, isOptionScoreOpen, modalOptionsDetails, optionsViewType, scoreLeft
      , tickOptions, uploadOptions } = this.state;
    //jury start date
    const juryReviewMilestone = milestoneFillListAE.find(
      (dateFilter) => dateFilter.milestone_name === 'Jury Review Round 1 Start Date'
    )?.milestone_date;
    const isMilestoneDateValidJuryStart = juryReviewMilestone !== undefined;
    const parseDDMMYYYYJuryStart = (dateString) => {
      const [day, month, year] = dateString.split('-').map(Number);
      return new Date(year, month - 1, day);
    };
    const milestoneDateObjJuryStart = isMilestoneDateValidJuryStart ? parseDDMMYYYYJuryStart(juryReviewMilestone) : null;
    const currentDateObjJuryStart = new Date();
    const juryReviewNotStarted = milestoneDateObjJuryStart && currentDateObjJuryStart < milestoneDateObjJuryStart;

    const applicationStartDate = milestoneFillListAE.find(
      (dateFilter) => dateFilter.milestone_name === 'Application Start Date'
    )?.milestone_date;

    const parseDDMMYYYY = (dateString) => {
      const [day, month, year] = dateString.split('-').map(Number);
      return new Date(year, month - 1, day);
    };
    //application start date
    const isMilestoneDateValidApplicationStart = applicationStartDate !== undefined;
    const milestoneDateObjApplicationStart = isMilestoneDateValidApplicationStart ? parseDDMMYYYY(applicationStartDate) : null;
    const currentDateObjApplicationStart = new Date();
    const isFutureDate = milestoneDateObjApplicationStart &&
      currentDateObjApplicationStart < milestoneDateObjApplicationStart;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">

            <div className="website-view">
              <Header data={[8]} />
            </div>
            <div className="mobile-view">
              <MobileHeader data={[8]} />
            </div>
            <section class='header_margin_top'>
              <div class="container-fluid">
                <div class="page-header">
                  <h2 className="mb-3 dashboard-tit  py-0 blog-name blog-name-1">
                    {award_event_id ? "Edit" : "Add"} Award Event
                  </h2>
                  <div className="Service_display pt-2">
                    <h6 className="Services_Active_or_Not">
                      {award_event_id ? is_active == 1 ? "Active" : "InActive" : "Active"}
                    </h6>
                    <div className="checkbox checbox-switch">
                      <label className="switch">
                        {award_event_id ? (
                          <>
                            <input type="checkbox" checked={is_active == 1}
                              onChange={() => {
                                if (is_active == 1) {
                                  this.setState({ is_active: 0 });
                                } else if (is_active == 0) {
                                  this.setState({ is_active: 1 });
                                }
                              }}
                            />
                            <span class="slider round"></span>
                          </>
                        ) : (
                          <>
                            <input type="checkbox" checked={1} />
                            <span class="slider round"></span>
                          </>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="">
                  <div className="company_info">
                    <fieldset>
                      <legend>Basic Details</legend>
                      <div className="outside_input_field ">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>
                                Award Event Name{" "}
                                <span className="mendatory_class">*</span>
                              </label>
                              <input type="text" maxLength={400} value={Event_Name}
                                onChange={(e) => this.setState({ Event_Name: e.target.value })}
                                class="form-control border-input border-input"
                                placeholder="Enter Award Event Name"
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {Event_NameErr}
                                </span>
                              }
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>
                                Award Event Period{" "}
                                <span className="mendatory_class">*</span>
                              </label>
                              <div className="row">
                                <div className="col-md-6">
                                  <input type="date" value={From_date}
                                    onChange={(e) => this.validateDates(e, 1)}
                                    className="form-control border-input border-input"
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {From_dateErr}
                                    </span>
                                  }
                                </div>
                                <div className="col-md-6">
                                  <input type="date" value={To_date}
                                    onChange={(e) => this.validateDates(e, 2)}
                                    className="form-control border-input border-input"
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {To_dateErr}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>
                                Launch Date-Time{" "}
                                <span className="mendatory_class">*</span>
                              </label>
                              <div className="row">
                                <div className="col-md-6">
                                  <input
                                    type="datetime-local"
                                    id="launchDate"
                                    value={launch_date}
                                    onChange={this.handleLaunchDateChange}
                                    className="form-control border-input border-input"
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {launch_dateErr}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label>
                                Award State <span className="mendatory_class">*</span>
                              </label>
                              <select value={award_state}
                                onChange={(e) => this.setState({ award_state: e.target.value })}
                                className="form-select border-input"
                              >
                                <option value="">Select State</option>
                                {stateFillList.map((state) => (
                                  <option key={state.state_id} value={state.state_id}>
                                    {state.state_name}
                                  </option>
                                ))}
                              </select>
                              <span className="text-danger text-start text-left d-block mt-1">
                                {award_stateErr}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label>
                                Award Country <span className="mendatory_class">*</span>
                              </label>
                              <select
                                value={award_country}
                                onChange={(e) => this.setState({ award_country: e.target.value })}
                                className="form-select border-input"
                              >
                                <option value="">Select Country</option>
                                {countryFillList.map((country) => (
                                  <option key={country.country_id} value={country.country_id}>
                                    {country.CountryName}
                                  </option>
                                ))}
                              </select>
                              <span className="text-danger text-start text-left d-block mt-1">
                                {award_countryErr}
                              </span>
                            </div>
                          </div>
                          <div className="row col-6">
                            <div class="col-md-5">
                              <div class="form-group mb-0">
                                <label>
                                  Weightage (Round 1){" "}
                                  <span className="mendatory_class">*</span>
                                </label>
                                <input
                                  type="text"
                                  maxLength={3}
                                  value={weightage_round1}
                                  onChange={(e) => {
                                    let value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                      if (value === "" || parseInt(value) <= 100) {
                                        this.setState({
                                          weightage_round1: value,
                                          weightage_round2: 100 - parseInt(value || "0")
                                        });
                                      }
                                    }
                                  }}
                                  className="form-control border-input"
                                  placeholder="Enter Round 1 weightage"
                                />
                                {
                                  <span className="text-danger text-start text-left d-block mt-1">
                                    {weightage_round1Err}
                                  </span>
                                }
                              </div>
                            </div>
                            <div class="col-md-5">
                              <div class="form-group mb-0">
                                <label>
                                  Weightage (Round 2){" "}
                                  <span className="mendatory_class">*</span>
                                </label>
                                <input type="text" disabled
                                  maxLength={10} value={weightage_round2}
                                  class="form-control border-input border-input"
                                />
                              </div>
                            </div>
                            <span className="text-danger text-start text-left d-block" style={{ fontSize: '12px' }} >{weightage_round1Note}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group mb-1">
                              <label>Award Address <span className="mendatory_class">*</span></label>
                              <textarea
                                maxLength={1000}
                                value={award_address}
                                onChange={(e) =>
                                  this.setState({
                                    award_address: e.target.value,
                                  })
                                }
                                class="form-control border-input"
                                rows={2}
                                defaultValue={""}
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {award_addressErr}
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group mb-1">
                              <label>Award Event Description</label>
                              <textarea
                                value={Event_Description}
                                onChange={(e) =>
                                  this.setState({
                                    Event_Description: e.target.value,
                                  })
                                }
                                class="form-control border-input"
                                rows={3}
                                maxLength={1000}
                                defaultValue={""}
                              />
                            </div>
                          </div>
                        </div>
                      </div></fieldset>
                    <fieldset>
                      <legend>Milestone</legend>
                      <div className="outside_input_field ">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="custom_table">
                                  <table className="table details-table " id="tbl">
                                    <thead>
                                      <tr>
                                        <th className="text-center" style={{ width: "3%" }}></th>
                                        <th style={{ width: "25%" }}>Stages</th>
                                        <th className="text-center" style={{ width: "6%" }}>Date</th>
                                        <th style={{ width: "10%" }} className="text-center">Visible to Applicant</th>
                                        <th style={{ width: "10%" }}>Stage Name for Applicant</th>
                                        <th className="text-right" style={{ width: "2%" }}></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {milestoneFillListAE.length > 0 ? (
                                        milestoneFillListAE.map((data, index) => (
                                          <tr key={index}>
                                            <td className="text-center">

                                              <label
                                                htmlFor={`ServiceCheck${index}`}
                                                className="lebel-dis"
                                                style={{ color: "#979797" }}
                                              >
                                                <input
                                                  type="checkbox"
                                                  id={`ServiceCheck${index}`}
                                                  checked={data.isSelected}
                                                  onChange={(e) =>
                                                    this.handleMilestoneRowEditFieldChangeAE(
                                                      index,
                                                      "isSelected",
                                                      e.target.checked, data
                                                    )
                                                  }
                                                />
                                              </label>
                                              <span></span>

                                            </td>
                                            <td>
                                              {editedMilestoneRowIndexAE === index ? (
                                                <input
                                                  type="text"
                                                  className="form-control border-input"
                                                  value={editedMilestoneRowDataAE.milestone_name}
                                                  onChange={(e) =>
                                                    this.handleMilestoneRowEditFieldChangeAE(
                                                      index,
                                                      "milestone_name",
                                                      e.target.value, data
                                                    )
                                                  }
                                                />
                                              ) : (
                                                data.milestone_name
                                              )}
                                            </td>
                                            <td className="text-center">
                                              {editedMilestoneRowIndexAE === index ? (
                                                <input
                                                  type="date"
                                                  value={
                                                    editedMilestoneRowDataAE.milestone_date && editedMilestoneRowDataAE.milestone_date !== ''
                                                      ? (() => {
                                                        const dateParts = editedMilestoneRowDataAE.milestone_date.split('-');
                                                        const day = dateParts[0];
                                                        const month = dateParts[1];
                                                        const year = dateParts[2];
                                                        return `${year}-${month}-${day}`;
                                                      })() : ''
                                                  }
                                                  onChange={(e) => {
                                                    const updatedDate = e.target.value;
                                                    const [year, month, day] = updatedDate.split('-');
                                                    const formattedDate = `${day}-${month}-${year}`;

                                                    this.setState((prevState) => {
                                                      const milestoneFillList = Array.isArray(prevState.milestoneFillListAE)
                                                        ? [...prevState.milestoneFillListAE]
                                                        : [];

                                                      if (milestoneFillList[prevState.editedMilestoneRowIndexAE]) {
                                                        milestoneFillList[prevState.editedMilestoneRowIndexAE] = {
                                                          ...milestoneFillList[prevState.editedMilestoneRowIndexAE],
                                                          milestone_date: formattedDate,
                                                        };
                                                      }
                                                      return {
                                                        milestoneFillListAE: milestoneFillList,
                                                        editedMilestoneRowDataAE: {
                                                          ...prevState.editedMilestoneRowDataAE,
                                                          milestone_date: formattedDate,
                                                        },
                                                      };
                                                    });
                                                  }}
                                                  className="form-control border-input"
                                                />
                                              ) : data.milestone_date ? data.milestone_date : ("")}
                                            </td>
                                            {/* Visibility Checkbox */}
                                            <td className="text-center">
                                              <label htmlFor={`VisibleCheck${index}`}
                                                className="lebel" style={{ color: "#979797" }}
                                              > <input type="checkbox" id={`VisibleCheck${index}`}
                                                checked={editedMilestoneRowIndexAE === index
                                                  ? editedMilestoneRowDataAE.is_visible_to_applicant
                                                  : data.is_visible_to_applicant}
                                                onChange={(e) =>
                                                  this.handleMilestoneRowEditFieldChangeAE(
                                                    index,
                                                    "is_visible_to_applicant",
                                                    e.target.checked, data
                                                  )
                                                }
                                                disabled={editedMilestoneRowIndexAE !== index}
                                                />
                                              </label>
                                              <span></span>

                                            </td>
                                            {/* Stage Name */}
                                            <td className="text-center">
                                              {editedMilestoneRowIndexAE === index ? (
                                                <input type="text" className="form-control border-input"
                                                  value={editedMilestoneRowDataAE.stage_name}
                                                  onChange={(e) =>
                                                    this.handleMilestoneRowEditFieldChangeAE(index, "stage_name", e.target.value, data)
                                                  }
                                                />
                                              ) : (
                                                data.stage_name
                                              )}
                                            </td>
                                            {/* Action Buttons */}
                                            <td className="text-center">
                                              {editedMilestoneRowIndexAE === index ? (
                                                <>
                                                  <a
                                                    title="Save Milestone"
                                                    className="mr-2"
                                                    onClick={() => this.saveEditedMilestoneRowAE(index)}
                                                  >
                                                    <i className="ri-save-line" />
                                                  </a>
                                                  <a
                                                    title="Cancel"
                                                    onClick={this.cancelEditMilestoneRowAE}
                                                  >
                                                    <i className="ri-close-line" />
                                                  </a>
                                                </>
                                              ) : (
                                                <>
                                                  <a
                                                    title="Edit Milestone"
                                                    className="mr-2 ml-3"
                                                    onClick={() =>
                                                      this.handleEditMilestoneRowAE(index, data)
                                                    }
                                                  >
                                                    <i class="fa fa-pencil-square-o text-primary" />
                                                  </a>
                                                  {data.is_fixed == true ? null : (
                                                    <>
                                                      <a title="Remove Milestone" className="text-danger"
                                                        onClick={() =>
                                                          this.handleDeleteMilestoneRowAE(index)
                                                        }
                                                      >
                                                        <i class="ri-delete-bin-line text-danger" />
                                                      </a>
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="6">No data available.</td>
                                        </tr>
                                      )}
                                      {/* Adding New Milestone */}
                                      {showNewMilestoneRowAE && (
                                        <tr>
                                          <td></td>
                                          <td>
                                            <input
                                              type="text"
                                              className="form-control border-input"
                                              value={milestoneDetailAE.milestone_name}
                                              onChange={(e) =>
                                                this.handleMilestoneDetailChangeAE(
                                                  "milestone_name",
                                                  e.target.value
                                                )
                                              }
                                              placeholder="Stage Name"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="date"
                                              value={milestoneDetailAE.milestone_date}
                                              onChange={(e) =>
                                                this.handleMilestoneDetailChangeAE(
                                                  "milestone_date",
                                                  e.target.value
                                                )
                                              }
                                              className="form-control border-input"
                                              disabled
                                            />
                                          </td>
                                          <td>
                                            <div className="bg only_checkbox">
                                              <div className="">
                                                <label
                                                  className="lebel-dis d-flex"
                                                  style={{ color: "#979797" }}
                                                >
                                                  <input
                                                    type="checkbox" className="mr-2"
                                                    disabled
                                                    checked={milestoneDetailAE.is_visible_to_applicant}
                                                  />
                                                  &nbsp;
                                                </label>
                                                <span></span>
                                              </div>
                                            </div>
                                          </td>
                                          <td>
                                            <input
                                              type="text"
                                              disabled
                                              className="form-control border-input"
                                              value={milestoneDetailAE.stage_name}
                                              placeholder="Stage Name for Applicant"
                                            />
                                          </td>
                                          <td>
                                            <button
                                              className="btn btn-primary btn-sm px-3"
                                              onClick={() => this.handleMileStoneMasterSubmit("AE")}
                                            >
                                              Add
                                            </button>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                  <div>
                                    <a
                                      href="javascript:void(0);"
                                      className="btn btn-outline-primary btn-sm px-4 mb-3 py-1"
                                      style={{ width: "auto" }}
                                      onClick={this.toggleNewMilestoneRowAE}
                                    >
                                      {showNewMilestoneRowAE ? "Cancel" : "Add"}
                                    </a>
                                    <a
                                      href="javascript:void(0);"
                                      class="btn btn-outline-primary btn px-4 mb-3 ml-2 btn-right"
                                      style={{ width: "auto" }}
                                      onClick={() => this.handleSubmit()}
                                    >
                                      {award_event_id ? "Update" : "Save"} {""} Milestone & Award Details
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div></fieldset>
                    {award_event_id ? <>
                      <fieldset>
                        <legend>Award Category</legend>
                        <div className="outside_input_field">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="custom_table">
                                <div className="hack1">
                                  <div className="hack2">
                                    <DragDropContext onDragEnd={this.onDragEndCategory}>
                                      <Droppable droppableId="awardCategoryList">
                                        {(provided) => (
                                          <table
                                            className="table details-table"
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                          >
                                            <thead>
                                              <tr>
                                                <th style={{ width: "30%" }}>Award Name</th>
                                                <th style={{ width: "10%" }}>Form</th>
                                                <th style={{ width: "8%" }}>Scoring Pattern</th>
                                                <th style={{ width: "8%" }}>Pricing & Milestone</th>
                                                <th className="text-center" style={{ width: "5%" }}></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {awardCategoryList.map((data, index) => (
                                                <Draggable
                                                  key={data.award_event_profile_id.toString()}
                                                  draggableId={data.award_event_profile_id.toString()}
                                                  index={index}
                                                >
                                                  {(provided, snapshot) => (
                                                    <tr
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                      className={snapshot.isDragging ? "dragging" : ""}
                                                    >
                                                      <td>
                                                        <a
                                                          style={{ cursor: "pointer", color: "#14adf5" }}
                                                          onClick={() =>
                                                            this.toggleModalAwardProfileOpen("profile", data.award_event_profile_id)
                                                          }
                                                        >
                                                          {data.award_name}
                                                        </a>
                                                      </td>
                                                      <td>
                                                        <span
                                                          style={{ cursor: "pointer", color: "#14adf5" }}
                                                          onClick={() =>
                                                            this.toggleModalAwardProfileOpen("application", data.award_event_profile_id)
                                                          }
                                                        >
                                                          Link
                                                        </span>
                                                      </td>
                                                      <td>
                                                        <span
                                                          style={{ cursor: "pointer", color: "#14adf5" }}
                                                          onClick={() =>
                                                            this.toggleModalAwardProfileOpen("scoring", data.award_event_profile_id)
                                                          }
                                                        >
                                                          Link
                                                        </span>
                                                      </td>
                                                      <td>
                                                        <span
                                                          style={{ cursor: "pointer", color: "#14adf5" }}
                                                          onClick={() =>
                                                            this.toggleModalAwardProfileOpen("Milestone", data.award_event_profile_id)
                                                          }
                                                        >
                                                          Link
                                                        </span>
                                                      </td>
                                                      <td className="text-right">
                                                        <>
                                                          {data.publish_status && (
                                                            <>
                                                              <a
                                                                title="Published"
                                                                className="btn btn-sm delete_record padding_0"
                                                              >
                                                                <i className="fa fa-check-square-o text-success"></i>
                                                              </a>
                                                              &nbsp;
                                                            </>
                                                          )}
                                                          <a
                                                            title="Delete"
                                                            className="btn btn-sm delete_record padding_0"
                                                            onClick={() =>
                                                              this.handleDeleteProfile(
                                                                data.award_event_id,
                                                                data.award_event_profile_id
                                                              )
                                                            }
                                                          >
                                                            <i className="ri-delete-bin-line text-danger" />
                                                          </a>
                                                        </>
                                                      </td>
                                                    </tr>
                                                  )}
                                                </Draggable>
                                              ))}
                                              {provided.placeholder}
                                            </tbody>
                                          </table>
                                        )}
                                      </Droppable>
                                    </DragDropContext>
                                    <div>
                                      <a
                                        href="javascript:void(0);"
                                        className="btn btn-outline-primary btn-sm px-4 mb-3 py-1"
                                        style={{ width: "auto" }}
                                        onClick={() => this.toggleModalAwardProfileOpen("profile", null)}
                                      >
                                        <span className="hidden-xs">
                                          {this.state.showNewAwardCategoryRow ? "Cancel" : "Add"}
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset>
                        <legend>Jury</legend>
                        <div className="outside_input_field">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="row mb-2">
                                <div className="col-md-12">
                                  <Select isMulti value={juryNameSelected}
                                    onChange={(selectedOptions) => {
                                      this.setState({ juryNameSelected: selectedOptions }, () => {
                                        const newAwardEventJuryDetails = selectedOptions.map(option => ({
                                          jury_id: option.value,
                                          jury: option.label,
                                          specialization: option.specialization || '',
                                        }));
                                        this.setState(prevState => {
                                          const updatedAwardEventJuryDetails = newAwardEventJuryDetails.filter(newEntry =>
                                            !prevState.awardEventJuryDetails.some(existingEntry => existingEntry.jury_id === newEntry.jury_id)
                                          );
                                          return updatedAwardEventJuryDetails.length > 0 ? {
                                            awardEventJuryDetails: [...prevState.awardEventJuryDetails, ...updatedAwardEventJuryDetails],
                                          } : null;
                                        });
                                      });
                                    }}
                                    options={juryNameFill}
                                    styles={customStyles}
                                    isClearable={false}
                                    isDisabled={!juryReviewNotStarted}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12">
                                  {/* <div className="custom_table" style={{ overflowX: "auto" }}>
                                    <table className="table details-table" id="tbl" style={{ tableLayout: "fixed", width: "100%", borderCollapse: "separate" }}>
                                      <thead>
                                        <tr>
                                          <th style={{
                                            position: "sticky", background: '#fff', left: 0, zIndex: 2,
                                            width: "67px", border: "1px solid #C6C6C6"
                                          }}></th>
                                          <th style={{
                                            position: "sticky", background: '#fff',
                                            left: "67px", zIndex: 2,
                                            width: "140px", border: "1px solid #C6C6C6"
                                          }}>Jury</th>
                                          <th style={{
                                            position: "sticky", background: '#fff',
                                            left: "207px", zIndex: 2, width: "250px", border: "1px solid #C6C6C6"
                                          }}>Specialization</th>
                                          {awardCategoryList?.map((item, idx) => (
                                            <th key={idx} style={{
                                              width: "200px", maxWidth: "10rem",
                                              wordWrap: "break-word", overflowWrap: "break-word",
                                              whiteSpace: "normal", textAlign: 'center',
                                              border: "1px solid #C6C6C6"
                                            }}>
                                              <label>{item.award_name}</label>
                                              {juryReviewNotStarted ? <>
                                                <input
                                                  type="checkbox"
                                                  onChange={(e) => this.handleSelectAll(item.award_event_profile_id, e.target.checked)}
                                                  checked={this.isAllSelected(item.award_event_profile_id)}
                                                />
                                              </> : <></>}
                                            </th>
                                          ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {juryNameSelected?.length > 0 ? (
                                          juryNameSelected.map((data, index) => (
                                            <tr key={index}>
                                              <td className="text-center" style={{
                                                position: "sticky",
                                                left: 0,
                                                background: "#fff",
                                                zIndex: 1,
                                                border: "1px solid #C6C6C6"
                                              }}>
                                                {juryReviewNotStarted ? <>
                                                  <a title="Remove Jury" onClick={() => this.handleDeleteRowJury(index)}>
                                                    <i className="ri-delete-bin-line text-danger"></i>
                                                  </a>
                                                </> : <></>}
                                              </td>
                                              <td style={{
                                                position: "sticky",
                                                left: "67px",
                                                background: "#fff",
                                                zIndex: 1,
                                                width: "140px", // Ensure consistent width with header
                                                border: "1px solid #C6C6C6"
                                              }}>{data.label}</td>
                                              <td style={{
                                                position: "sticky",
                                                left: "207px", // Match cumulative width from the header
                                                background: "#fff",
                                                zIndex: 1,
                                                width: "250px", // Ensure consistent width with header
                                                border: "1px solid #C6C6C6"
                                              }}>{data.specialization}</td>
                                              {awardCategoryList.map((item, i) => (
                                                <td key={i} style={{
                                                  maxWidth: "50px",
                                                  textAlign: 'center',
                                                  border: "1px solid #C6C6C6"
                                                }}>
                                                  <label htmlFor={`ServiceCheck2${index}${item.award_event_profile_id}`} className="lebel-dis" style={{ color: "#979797" }}>
                                                    <input
                                                      disabled={!juryReviewNotStarted}
                                                      type="checkbox"
                                                      id={`ServiceCheck2${index}${item.award_event_profile_id}`}
                                                      checked={this.state.awardEventJuryDetails[index]?.[item.award_event_profile_id]?.isChecked || false}
                                                      onChange={(e) =>
                                                        this.handleCheckboxChangeJury(index, e.target.checked, item.award_event_profile_id)
                                                      }
                                                    />
                                                  </label>
                                                  <span></span>
                                                </td>
                                              ))}
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan={3 + awardCategoryList.length}>No data available.</td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div> */}

                                  <div
                                    className="custom_table"
                                    style={{
                                      overflowX: "auto",
                                      overflowY: "auto",
                                      maxHeight: "500px", // Fixed height for bottom spacing
                                      position: "relative",
                                    }}
                                  >
                                    <table
                                      className="table details-table"
                                      id="tbl"
                                      style={{
                                        tableLayout: "fixed",
                                        width: "100%",
                                        borderCollapse: "separate",
                                        position: "relative",
                                      }}
                                    >
                                      <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 3 }}>
                                        <tr>
                                          <th
                                            style={{
                                              position: "sticky",
                                              background: "#fff",
                                              left: 0,
                                              zIndex: 2,
                                              width: "67px",
                                              border: "1px solid #C6C6C6",
                                            }}
                                          ></th>
                                          <th
                                            style={{
                                              position: "sticky",
                                              background: "#fff",
                                              left: "67px",
                                              zIndex: 2,
                                              width: "140px",
                                              border: "1px solid #C6C6C6",
                                            }}
                                          >
                                            Jury
                                          </th>
                                          <th
                                            style={{
                                              position: "sticky",
                                              background: "#fff",
                                              left: "207px",
                                              zIndex: 2,
                                              width: "250px",
                                              border: "1px solid #C6C6C6",
                                            }}
                                          >
                                            Specialization
                                          </th>
                                          {awardCategoryList?.map((item, idx) => (
                                            <th
                                              key={idx}
                                              style={{
                                                width: "200px",
                                                maxWidth: "10rem",
                                                wordWrap: "break-word",
                                                overflowWrap: "break-word",
                                                whiteSpace: "normal",
                                                textAlign: "center",
                                                border: "1px solid #C6C6C6",
                                              }}
                                            >
                                              <label>{item.award_name}</label>
                                              {juryReviewNotStarted ? (
                                                <input
                                                  type="checkbox"
                                                  onChange={(e) =>
                                                    this.handleSelectAll(item.award_event_profile_id, e.target.checked)
                                                  }
                                                  checked={this.isAllSelected(item.award_event_profile_id)}
                                                />
                                              ) : null}
                                            </th>
                                          ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {juryNameSelected?.length > 0 ? (
                                          juryNameSelected.map((data, index) => (
                                            <tr key={index}>
                                              <td
                                                className="text-center"
                                                style={{
                                                  position: "sticky",
                                                  left: 0,
                                                  background: "#fff",
                                                  zIndex: 1,
                                                  border: "1px solid #C6C6C6",
                                                }}
                                              >
                                                {juryReviewNotStarted ? (
                                                  <a title="Remove Jury" onClick={() => this.handleDeleteRowJury(index)}>
                                                    <i className="ri-delete-bin-line text-danger"></i>
                                                  </a>
                                                ) : null}
                                              </td>
                                              <td
                                                style={{
                                                  position: "sticky",
                                                  left: "67px",
                                                  background: "#fff",
                                                  zIndex: 1,
                                                  width: "140px",
                                                  border: "1px solid #C6C6C6",
                                                }}
                                              >
                                                {data.label}
                                              </td>
                                              <td
                                                style={{
                                                  position: "sticky",
                                                  left: "207px",
                                                  background: "#fff",
                                                  zIndex: 1,
                                                  width: "250px",
                                                  border: "1px solid #C6C6C6",
                                                }}
                                              >
                                                {data.specialization}
                                              </td>
                                              {awardCategoryList.map((item, i) => (
                                                <td
                                                  key={i}
                                                  style={{
                                                    maxWidth: "50px",
                                                    textAlign: "center",
                                                    border: "1px solid #C6C6C6",
                                                  }}
                                                >
                                                  <label
                                                    htmlFor={`ServiceCheck2${index}${item.award_event_profile_id}`}
                                                    className="lebel-dis"
                                                    style={{ color: "#979797" }}
                                                  >
                                                    <input
                                                      disabled={!juryReviewNotStarted}
                                                      type="checkbox"
                                                      id={`ServiceCheck2${index}${item.award_event_profile_id}`}
                                                      checked={
                                                        this.state.awardEventJuryDetails[index]?.[
                                                          item.award_event_profile_id
                                                        ]?.isChecked || false
                                                      }
                                                      onChange={(e) =>
                                                        this.handleCheckboxChangeJury(
                                                          index,
                                                          e.target.checked,
                                                          item.award_event_profile_id
                                                        )
                                                      }
                                                    />
                                                  </label>
                                                  <span></span>
                                                </td>
                                              ))}
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan={3 + awardCategoryList.length}>No data available.</td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>

                                  <button disabled={!juryReviewNotStarted}
                                    href="javascript:void(0);"
                                    class="btn btn-outline-primary btn px-4 mb-3 mt-2"
                                    style={{ width: "auto" }}
                                    onClick={() => this.handleSubmitJury()}
                                  >
                                    {juryReviewNotStarted ? <>Submit Jury</> : <><span className="text-danger text-start text-left d-block mt-1">Jury Review Started</span></>}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                    </> : <></>}

                  </div>
                </div>
                {/* award profile*/}
                <Modal
                  show={isAwardProfileModal}
                  className="custom-modal mt-2"
                // fullscreen
                >
                  <Modal.Header className="" >
                    <div class="container-fluid">
                      <div class="page-header  p-0 pt-1 pb-0 m-0">
                        <h4 class="page-title">
                          {award_event_profile_id ? "Edit" : "Add"} Award Profile {award_event_profile_id ? `- ${award_name}` : ''}
                        </h4>
                        <div className="Service_display">
                          <h1
                            className=""
                            style={{
                              fontSize: "17px",
                              fontWeight: "800",
                              cursor: "pointer",
                            }}
                            onClick={() => this.toggleModalAwardProfileClose()}
                          >
                            X
                          </h1>
                        </div>
                      </div>
                    </div>
                  </Modal.Header>
                  <Modal.Body className="pt-2 p-0">
                    <div class="container-fluid">

                      <Tab.Container defaultActiveKey={APOpenMode == "profile" ? "Profile" : APOpenMode == "application" ? "Application" : APOpenMode == "scoring" ? "Scoring" : APOpenMode == "Milestone" ? "Milestone" : "Profile"}>
                        <Nav
                          variant="tabs"
                          className="nav nav-tabs nav-tabs-custom nav-success mb-3 myOrderTabs"
                          role="tablist"
                        >
                          <Nav.Item className="tabs-border">
                            <Nav.Link eventKey="Profile" className="tabs-color">
                              {/* <i className="ri-store-2-fill me-1 align-bottom" />{" "} */}
                              Profile
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item className="tabs-border">
                            <Nav.Link eventKey="Application" className="tabs-color">
                              {/* <i className="ri-arrow-left-right-fill me-1 align-bottom" />{" "} */}
                              Application Form
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item className="tabs-border">
                            <Nav.Link eventKey="Scoring" className="tabs-color">
                              {/*  <i className="ri-arrow-left-right-fill me-1 align-bottom" />{" "} */}
                              Scoring Pattern
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item className="tabs-border">
                            <Nav.Link eventKey="Milestone" className="tabs-color">
                              {/* <i className="ri-arrow-left-right-fill me-1 align-bottom" />{" "} */}
                              Pricing & Milestone
                            </Nav.Link>
                          </Nav.Item>
                        </Nav>
                        <Tab.Content className="edit-award-rofile-body pr-1">
                          <Tab.Pane eventKey="Profile">
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="form-group">
                                    <label>
                                      Section Label{" "}
                                      <span className="mendatory_class">
                                        *
                                      </span>
                                    </label>
                                    <input
                                      type="text"
                                      value={section_label}
                                      disabled={publish_status}
                                      onChange={(e) =>
                                        this.setState({
                                          section_label: e.target.value,
                                        })
                                      }
                                      class="form-control border-input"
                                      placeholder="Enter Section Label"
                                    /> {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {section_labelErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label>
                                      Award Name{" "}
                                      <span className="mendatory_class">
                                        *
                                      </span>
                                    </label>
                                    <input
                                      type="text"
                                      value={award_name}
                                      disabled={publish_status}
                                      onChange={(e) =>
                                        this.setState({
                                          award_name: e.target.value,
                                        })
                                      }
                                      class="form-control border-input"
                                      placeholder="Enter Award Event Name"
                                    /> {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {award_nameErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <span class="floating-label-outside">
                                      Category{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                    <Select
                                      isMulti
                                      isDisabled={publish_status}
                                      value={categoryNameSelected}
                                      onChange={(e) => this.setState({ categoryNameSelected: e })}
                                      options={categoryFillList}
                                      styles={customStyles}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {category_idErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <span class="floating-label-outside">
                                      Applicant Type{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                    <Select
                                      isMulti
                                      isDisabled={publish_status}
                                      value={applicantNameSelected}
                                      onChange={(e) => this.setState({ applicantNameSelected: e })}
                                      options={applicantTypeFillList}
                                      styles={customStyles}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {applicant_type_idErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label>
                                      Award Payable Type{" "}
                                      <span className="mendatory_class">
                                        *
                                      </span>
                                    </label>
                                    <select
                                      className="form-select border-input"
                                      name="TimeSlot"
                                      value={award_type}
                                      disabled={publish_status}
                                      onChange={(e) => {
                                        this.setState({
                                          award_type: e.target.value,
                                          award_typeErr: ''
                                        });
                                      }}
                                    >
                                      <option value="">Select</option>
                                      <option value="Paid">Paid</option>
                                      <option value="Free">Free</option>

                                    </select>
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {award_typeErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <span class="floating-label-outside">
                                      GST Applicable{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                    <select
                                      className="form-select border-input"
                                      disabled={publish_status}
                                      name="TimeSlot"
                                      value={is_gst_applicable}
                                      onChange={(e) => {
                                        this.setState({
                                          is_gst_applicable: e.target.value,
                                        });
                                      }}
                                    >
                                      <option value={null}>Select</option>
                                      <option value={1}>Yes</option>
                                      <option value={0}>No</option>
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {is_gst_applicableErr}
                                        </span>
                                      }
                                    </select>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <span class="floating-label-outside">
                                      Nomination Process{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                    <select
                                      className="form-select border-input"
                                      name="TimeSlot"
                                      disabled={publish_status}
                                      value={nomination_process_id}
                                      onChange={(e) => {
                                        this.setState({
                                          nomination_process_id: e.target.value,
                                          nomination_process_idErr: ''
                                        });
                                      }}
                                    >
                                      <option value="">Select</option>
                                      {nominationProcessFillList.map((data) => (
                                        <option
                                          key={data.nomination_process_id}
                                          value={data.nomination_process_id}
                                        >
                                          {data.nomination_process_name}
                                        </option>
                                      ))}
                                    </select>
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {nomination_process_idErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-12 mt-1">
                                  <div class="form-group">
                                    <label className="pop-title pb-1">Description</label>
                                    <JoditEditor
                                      key={`description-${award_event_profile_id || 'new'}`}
                                      defaultValue={description}
                                      config={publish_status ? this.stableJoditConfigReadOnly : this.stableJoditConfigNormal}
                                      onBlur={(newContent) => this.handleAwardProfileEditor(newContent, 'description')}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {descriptionErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                                <div class="col-md-12 mt-1">
                                  <div class="form-group">
                                    <label className="pop-title pb-1">
                                      Theme
                                    </label>
                                    <JoditEditor
                                      key={`theme-${award_event_profile_id || 'new'}`}
                                      defaultValue={theme}
                                      config={publish_status ? this.stableJoditConfigReadOnly : this.stableJoditConfigNormal}
                                      onBlur={(newContent) => this.handleAwardProfileEditor(newContent, 'theme')}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {themeErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                                <div class="col-md-12 mt-1">
                                  <div class="form-group">
                                    <label className="pop-title pb-1">
                                      Eligibility/ Criteria for application/
                                      rules for applicants/ Nomination
                                      Criteria
                                    </label>
                                    <JoditEditor
                                      key={`eligibility-${award_event_profile_id || 'new'}`}
                                      defaultValue={eligibility_criteria}
                                      config={publish_status ? this.stableJoditConfigReadOnly : this.stableJoditConfigNormal}
                                      onBlur={(newContent) => this.handleAwardProfileEditor(newContent, 'eligibility_criteria')}
                                    />
                                    {<span className="text-danger text-start text-left d-block mt-1">
                                      {eligibility_criteriaErr}
                                    </span>
                                    }
                                  </div>
                                </div>
                                <div class="col-md-12 mt-1">
                                  <div class="form-group">
                                    <label className="pop-title pb-1">
                                      Jury Selection Criteria / Profile Fresh
                                      Jury Panel
                                    </label>
                                    <JoditEditor
                                      key={`jury-${award_event_profile_id || 'new'}`}
                                      defaultValue={jury_selection_criteria}
                                      config={publish_status ? this.stableJoditConfigReadOnly : this.stableJoditConfigNormal}
                                      onBlur={(newContent) => this.handleAwardProfileEditor(newContent, 'jury_selection_criteria')}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {jury_selection_criteriaErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                                <div class="col-md-12 mt-1">
                                  <div class="form-group">
                                    <label className="pop-title pb-1">Screening Process</label>
                                    <JoditEditor
                                      key={`screening-${award_event_profile_id || 'new'}`}
                                      defaultValue={screening_process}
                                      config={publish_status ? this.stableJoditConfigReadOnly : this.stableJoditConfigNormal}
                                      onBlur={(newContent) => this.handleAwardProfileEditor(newContent, 'screening_process')}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {screening_processErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                                <div class="col-md-12 mt-1">
                                  <div class="form-group">
                                    <label className="pop-title pb-1">
                                      Important Instructions
                                    </label>
                                    <JoditEditor
                                      key={`instructions-${award_event_profile_id || 'new'}`}
                                      defaultValue={important_instructions}
                                      config={publish_status ? this.stableJoditConfigReadOnly : this.stableJoditConfigNormal}
                                      onBlur={(newContent) => this.handleAwardProfileEditor(newContent, 'important_instructions')}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {important_instructionsErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                                <div class="col-md-12 mt-1">
                                  <div class="form-group">
                                    <label className="pop-title pb-1">
                                      Supporting Documents / List of
                                      supporting elements
                                    </label>
                                    <JoditEditor
                                      key={`supporting-${award_event_profile_id || 'new'}`}
                                      defaultValue={list_of_supporting_elements}
                                      config={publish_status ? this.stableJoditConfigReadOnly : this.stableJoditConfigNormal}
                                      onBlur={(newContent) => this.handleAwardProfileEditor(newContent, 'list_of_supporting_elements')}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {list_of_supporting_elementsErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="mt-1">
                                  <a href="javascript:void(0);"
                                    onClick={() => this.toggleModalAwardProfileClose()}
                                    class="btn btn-outline-secondary btn px-4 mb-3 ml-2 btn-right"
                                  >
                                    Back
                                  </a>
                                  {publish_status ? <></> : <>
                                    <a
                                      href="javascript:void(0);"
                                      class="btn btn-outline-primary btn px-4 mb-3 ml-2 btn-right"
                                      onClick={() => this.handleAwardProfileSubmit()}
                                    >
                                      {award_event_profile_id ? "Update" : "Save"}
                                    </a>
                                  </>}

                                </div>

                              </div>
                            </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Application">
                            <div class="card-body">
                              {award_event_profile_id ? (<>
                                <div className="row">
                                  <div className="d-flex justify-content-end">
                                    {publish_status ? <></> : <>
                                      <a
                                        href="javascript:void(0);"
                                        className="btn btn-outline-primary btn-sm px-4 mb-3 py-1 d-flex align-items-center mr-2"
                                        style={{ width: "max-content" }}
                                        onClick={() => this.toggleApplicationSectionModal1Open(award_event_profile_id)}
                                      >
                                        <i className="ri-add-line"></i>{""}Add Dynamic Fields
                                      </a>
                                    </>}
                                    <a
                                      href="javascript:void(0);"
                                      className="btn btn-outline-primary btn-sm px-4 mb-3 py-1 d-flex align-items-center ml-2"
                                      style={{ width: "min-content" }}
                                      onClick={() => this.toggleInstructionDetails()}
                                    >
                                      <i className="ri-information-line mr-2"></i>{""}Instructions
                                    </a>
                                  </div>
                                </div>

                                <div className="company_info">
                                  {this.state.applicationSectionNameList.map((sections, sectionIndex) => (
                                    <fieldset key={sectionIndex}>
                                      <legend>
                                        {this.state.isSectionEdit === sectionIndex ? (
                                          <>
                                            <input
                                              value={sections.section_name}
                                              onChange={(e) => this.handleSectionNameChange(e, sectionIndex)}
                                            />
                                            <a title="Close">
                                              <i
                                                className="ri-save-line"
                                                onClick={() => this.toggleSectionName(sectionIndex)}
                                              ></i>
                                            </a>
                                          </>
                                        ) : (
                                          <>
                                            {sections.section_name}
                                            {publish_status ? <></> : <>
                                              <a title="Edit" class='ml-2'>
                                                <i
                                                  class="fa fa-pencil-square-o text-primary mr-1"
                                                  onClick={() => this.toggleSectionName(sectionIndex)}
                                                ></i>
                                                {this.state.applicationSectionNameList.length > 1 && (
                                                  <a title="Remove">
                                                    <i
                                                      class="ri-delete-bin-line text-danger"
                                                      onClick={() => this.removeSection(sectionIndex, sections.section_name)}
                                                    ></i>
                                                  </a>
                                                )}
                                              </a></>}
                                          </>
                                        )}
                                      </legend>
                                      <div className="outside_input_field">
                                        <div className="form-group row">
                                          <DragDropContext onDragEnd={this.onDragEndField}>
                                            <Droppable droppableId={`fields-${sections.section_name}`}>
                                              {(provided) => (
                                                <div
                                                  className="row"
                                                  ref={provided.innerRef}
                                                  {...provided.droppableProps}
                                                >
                                                  {applicationSectionFieldList.filter((data) => data.section_name === sections.section_name)
                                                    .sort((a, b) => a.seq_no - b.seq_no)
                                                    .map((field, index) => {
                                                      const sectionType = controlTypeAPFillList.find(
                                                        (item) => item.controltype_id === parseInt(field.controltype_id)
                                                      );
                                                      const optionsArray = field.options ? field.options : [];
                                                      return (
                                                        <Draggable
                                                          key={field?.award_event_profile_section_fields_id?.toString()}
                                                          draggableId={field?.award_event_profile_section_fields_id?.toString()}
                                                          index={index}
                                                        >
                                                          {(provided) => (
                                                            <div className="col-md-6 mt-3"
                                                              ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                              <label className={`pb-1`} style={{ cursor: "grab" }}>
                                                                {field.fieldname}{" "} {field.is_mandatory == 1 && (
                                                                  <span className="mendatory_class">*</span>)}{" "}
                                                                {!publish_status && (
                                                                  <>
                                                                    <i className="fa fa-pencil-square-o text-primary mr-1"
                                                                      onClick={() => this.toggleApplicationSectionModal2Open(
                                                                        award_event_profile_id, field, "update")}
                                                                    ></i>{" "}
                                                                    <i className="ri-delete-bin-line text-danger"
                                                                      style={{ cursor: "pointer" }}
                                                                      onClick={() => this.removeField(field.section_name, field.seq_no)}
                                                                    ></i>
                                                                  </>
                                                                )}
                                                              </label>
                                                              {sectionType ? (
                                                                (() => {
                                                                  switch (sectionType.controltype) {
                                                                    case "Dropdown - Single-Select":
                                                                      return (
                                                                        <select className="form-select border-input"
                                                                          disabled={publish_status}>
                                                                          <option value="">Select {field.fieldname}</option>
                                                                          {optionsArray.map((option, index) => (
                                                                            <option key={index} value={option}>
                                                                              {option}
                                                                            </option>
                                                                          ))}
                                                                        </select>
                                                                      );
                                                                    case "Dropdown - Multi-Select":
                                                                      return (
                                                                        <Select isDisabled={publish_status}
                                                                          isMulti placeholder={field.fieldname}
                                                                          options={optionsArray.map((option) => ({
                                                                            value: option, label: option,
                                                                          }))}
                                                                        />
                                                                      );
                                                                    case "Checkbox - Single-Select":
                                                                    case "Checkbox - Multi-Select":
                                                                      return optionsArray.map((option, index) => (
                                                                        <div key={index}>
                                                                          <label className="py-0 pb-1 d-flex"
                                                                            style={{ marginLeft: "3px" }}>
                                                                            <input type="checkbox"
                                                                              disabled={publish_status}
                                                                              className="mr-2" />
                                                                            {option}
                                                                          </label>
                                                                        </div>
                                                                      ));
                                                                    case "Text Box - Numeric":
                                                                    case "Text Box - Decimal":
                                                                    case "Text Box - AlphaNumeric":
                                                                    case "Text Box - Email":
                                                                    case "Text Box - Website":
                                                                    case "Text Box - Phone Number":
                                                                      return (
                                                                        <input type="text"
                                                                          className="form-control border-input"
                                                                          placeholder={field.fieldname}
                                                                          maxLength={field.max_length}
                                                                          disabled={publish_status}
                                                                        />
                                                                      );
                                                                    case "Multiline Text Box":
                                                                      return (
                                                                        <textarea placeholder={field.fieldname}
                                                                          className="form-control border-input"
                                                                          maxLength={field.max_length}
                                                                          disabled={publish_status}
                                                                        ></textarea>
                                                                      );
                                                                    case "Date Picker":
                                                                      return (
                                                                        <input type="date"
                                                                          className="form-control border-input"
                                                                          disabled={publish_status} />
                                                                      );
                                                                    case "File Upload":
                                                                      return (
                                                                        <div className="upload__btn-box">
                                                                          <label className="upload__btn">
                                                                            <input type="file"
                                                                              className="upload__inputfile"
                                                                              disabled={publish_status}
                                                                            />
                                                                          </label>
                                                                        </div>
                                                                      );
                                                                    default:
                                                                      return <div>Unsupported control type</div>;
                                                                  }
                                                                })()
                                                              ) : (
                                                                <div>Control type not found</div>
                                                              )}
                                                            </div>
                                                          )}
                                                        </Draggable>
                                                      );
                                                    })}
                                                  {provided.placeholder}
                                                </div>
                                              )}
                                            </Droppable>
                                          </DragDropContext>
                                        </div>
                                        {publish_status ? <></> : <>
                                          <div className="form-group row">
                                            <a
                                              href="javascript:void(0);"
                                              className="btn btn-primary btn-sm px-3 create_btn add_additional_days_btn d-flex align-items-center ml-3"
                                              style={{ width: "max-content" }}
                                              onClick={() =>
                                                this.toggleApplicationSectionModal2Open(award_event_profile_id, sections, 'add')
                                              }
                                            >
                                              <i className="ri-add-line"></i>Add Dynamic Fields
                                            </a>
                                          </div>
                                        </>}
                                      </div>
                                    </fieldset>
                                  ))}
                                  {publish_status ? <></> : <>
                                    <a
                                      href="javascript:void(0);"
                                      className="btn btn-outline-primary btn-sm px-4 mb-3 py-1 d-flex align-items-center"
                                      style={{ width: "max-content" }}
                                      onClick={this.addSection}
                                    >
                                      <i className="ri-add-line"></i> Add Section
                                    </a>
                                  </>}
                                </div>
                                <div className="company_info">
                                  <fieldset>
                                    <legend>Declaration</legend>
                                    <div className="outside_input_field">
                                      <div className="form-group row">
                                        <div className="col-md-12">
                                          <label><b>Declaration Message</b></label>
                                          <JoditEditor
                                            key={`decl-msg-${award_event_profile_id || 'new'}`}
                                            defaultValue={this.state.award_event_profile_declaration_message}
                                            config={publish_status ? this.stableJoditConfigReadOnly : this.stableJoditConfigNormal}
                                            onBlur={(newContent) => this.handleAwardProfileEditor(newContent, 'award_event_profile_declaration_message')}
                                          />
                                        </div>
                                        <div className="col-md-12 mt-2">
                                          <label><b>Declaration</b></label>
                                          <JoditEditor
                                            key={`decl-${award_event_profile_id || 'new'}`}
                                            defaultValue={this.state.award_event_profile_declaration}
                                            config={publish_status ? this.stableJoditConfigReadOnly : this.stableJoditConfigNormal}
                                            onBlur={(newContent) => this.handleAwardProfileEditor(newContent, 'award_event_profile_declaration')}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </fieldset>
                                </div>
                                <Modal show={isInstructionsOpen}
                                  size="xl"
                                >
                                  <Modal.Body>

                                    <div class="container-fluid">
                                      <div class="page-header">
                                        <h4 class="page-title">Instructions</h4>
                                        <div className="Service_display pt-2">
                                          <h1
                                            className="Services_Active_or_Not"
                                            style={{
                                              fontSize: "25px",
                                              fontWeight: "800",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => this.toggleInstructionDetails()}
                                          >
                                            X
                                          </h1>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-12">
                                          <div className="awards-container">
                                            <div className="awards-row">
                                              <div className="label">Category </div>
                                              <div className="content">{category_names}</div>
                                            </div>
                                            {theme != "" ?
                                              <div className="awards-row">
                                                <div className="label">Theme</div>
                                                <div className="content">
                                                  <div dangerouslySetInnerHTML={{
                                                    __html: purify.sanitize(theme)
                                                  }}
                                                  />
                                                </div>
                                              </div>
                                              : <></>}
                                            {eligibility_criteria != "" ?
                                              <div className="awards-row">
                                                <div className="label">Eligibility</div>
                                                <div className="content">
                                                  <div dangerouslySetInnerHTML={{
                                                    __html: purify.sanitize(eligibility_criteria)
                                                  }}
                                                  />
                                                </div>
                                              </div>
                                              : <></>}
                                            {screening_process != "" ?
                                              <div className="awards-row">
                                                <div className="label">Screening Process</div>
                                                <div className="content">
                                                  <div dangerouslySetInnerHTML={{
                                                    __html: purify.sanitize(screening_process)
                                                  }}
                                                  />
                                                </div>
                                              </div>
                                              : <></>}
                                            {important_instructions != "" ?
                                              <div className="awards-row">
                                                <div className="label">Important Instructions</div>
                                                <div className="content">
                                                  <div dangerouslySetInnerHTML={{
                                                    __html: purify.sanitize(important_instructions)
                                                  }}
                                                  />
                                                </div>
                                              </div>
                                              : <></>}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Modal.Body>
                                </Modal>
                                {award_event_profile_id ? <>
                                  <div class="row">
                                    <div class="">
                                      {publish_status ? <></> : <>
                                        <a
                                          href="javascript:void(0);"
                                          class="btn btn-outline-primary btn px-4 mb-3 ml-2 btn-right"
                                          onClick={() => this.handleAwardProfileApplicationSubmit()}
                                        >{award_event_profile_id ? "Update" : "Save"}
                                        </a>
                                      </>}
                                      <a
                                        href="javascript:void(0);"
                                        onClick={() => this.toggleModalAwardProfileClose()}
                                        class="btn btn-outline-secondary btn px-4 mb-3 ml-2 btn-right"
                                      >
                                        Back
                                      </a>
                                      {publish_status ? (
                                        <>
                                          {isFutureDate && (
                                            <a
                                              href="javascript:void(0);"
                                              onClick={() => this.togglePublish(0)}
                                              className="btn btn-outline-success btn px-4 mb-3 ml-2 btn-right"
                                            >
                                              Revoke
                                            </a>
                                          )
                                          }
                                        </>
                                      ) : (
                                        <a
                                          href="javascript:void(0);"
                                          class="btn btn-outline-success btn px-4 mb-3 ml-2 btn-right"
                                          onClick={() => this.togglePublish(1)}
                                        >
                                          Publish
                                        </a>

                                      )}
                                    </div>
                                    <Modal show={publishView} size="md" style={{ backdropFilter: 'blur(5px)' }}>
                                      <Modal.Header>
                                        <Modal.Title style={{ width: '100%', textAlign: 'center' }}>
                                          {publishSubmitType ? <h6>Publish Award Category</h6> : <h6>Revoke Award Category</h6>}
                                        </Modal.Title>
                                        <span
                                          onClick={() => this.togglePublish()}
                                          style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                                        >
                                          X
                                        </span>
                                      </Modal.Header>
                                      <Modal.Body>
                                        <div>
                                          <p className="mb-1 mt-1 text-center com-font">
                                            Are You Sure You Want To {publishSubmitType == 1 ? 'Publish' : 'Revoke'} This Award Category?
                                          </p>
                                          {publishSubmitType ? <>
                                            <ul>
                                              <li className="text-danger">
                                                <small>
                                                  Note: Once Published, You Cannot Make Any Changes
                                                </small>
                                              </li>
                                              <li className="text-danger"><small>
                                                Note: Scoring Pattern will remain editable till the date when jury starts application review
                                              </small> </li>
                                              <li className="text-danger"><small>
                                                Note: Make sure to fill applicant type fee before publishing the award category
                                              </small></li>
                                            </ul>
                                          </> : <>
                                            <ul>
                                              <li className="text-danger">
                                                <small>Note: Once Revoked, All feilds related to this award category will be editable again till you Publish this Award</small>
                                              </li>
                                            </ul>
                                          </>}
                                        </div>
                                      </Modal.Body>

                                      <Modal.Footer style={{ justifyContent: 'left' }}>
                                        <div class="row">
                                          <div class="col-md-12">
                                            <button
                                              onClick={() => this.publishForm(award_event_id, award_event_profile_id, publishSubmitType)}
                                              class="btn btn-warning mr-2"
                                              style={{ cursor: 'pointer' }}
                                            >
                                              {publishSubmitType === 1 ? 'Publish' : 'Revoke'}
                                            </button>
                                            <button
                                              onClick={() => this.togglePublish()}
                                              class="btn btn-dark"
                                              style={{ cursor: 'pointer', width: 'auto' }}
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        </div>

                                      </Modal.Footer>
                                    </Modal>

                                  </div>
                                </> : <></>}
                              </>) : <>
                                <div className="px-3">
                                  <div class="page-header">
                                    <h4 class="page-title text-center">
                                      Kindly Fill the Award Profile Details to Proceed
                                    </h4>
                                  </div>
                                </div>
                              </>}
                            </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Scoring">
                            {award_event_profile_id ? <>
                              <div class="row">
                                <div class="col-md-12">
                                  <span className="text-danger text-start text-left d-block mr-4 mb-2" style={{ float: 'left' }} >Note: Total Scoring Alloted for Round 1: {weightage_round1}</span>
                                  <span className="text-danger text-start text-left d-block mb-2">Note: Scoring left for Round 1: {scoreLeft !== null && scoreLeft !== undefined ? scoreLeft : weightage_round1}</span>

                                  <div class="custom_table">
                                    <div class="hack1">
                                      <div class="hack2">
                                        <table
                                          class="table details-table "
                                          id="tbl"
                                        >
                                          <thead>
                                            <tr>
                                              <th style={{ width: "10%" }}>
                                                Round
                                              </th>
                                              <th style={{ width: "15%" }}>
                                                Scoring Mode
                                              </th>
                                              <th style={{ width: "15%" }}>
                                                Marking Pattern
                                              </th>
                                              <th style={{ width: "15%" }}>
                                                Scoring Pattern Name
                                              </th>
                                              <th style={{ width: "15%" }}>
                                                Description
                                              </th>
                                              <th style={{ width: "10%" }}>
                                                Max Score
                                              </th>
                                              <th style={{ width: "10%" }}>
                                                Automated Type
                                              </th>
                                              <th style={{ width: "15%" }}>
                                                Scoring Formula
                                              </th>
                                              <th style={{ width: "10%" }}>
                                                Options
                                              </th>
                                              {juryReviewNotStarted ? (
                                                <th className="text-right" style={{ width: "2%" }}></th>
                                              ) : <></>}
                                            </tr>
                                          </thead>
                                          <tbody id="myTable">
                                            {scoringPatternList.filter((data) => data.is_active == 1).length > 0 ? (
                                              scoringPatternList.filter((data) => data.is_active == 1).map((data, index) => (
                                                <tr key={index}>
                                                  <td>{this.state.editedScoringPatternRowIndex === index ? (
                                                    <select className="form-select border-input" name="TimeSlot"
                                                      value={scoringPatternDetail.round_id || data.round_id}
                                                      onChange={(e) => {
                                                        const selectedround_id = e.target.value;
                                                        this.setState((prevState) => ({
                                                          scoringPatternDetail:
                                                            { ...scoringPatternDetail, round_id: selectedround_id, },
                                                          editedScoringPatternRowData: {
                                                            ...prevState.editedScoringPatternRowData,
                                                            round_id: selectedround_id,
                                                          },
                                                        }));
                                                      }}>
                                                      <option value="">--Select--</option>
                                                      {scoringRoundFillList.map((data) => (<option value={data.round_id}>{data.round_name}</option>
                                                      ))}</select>
                                                  ) : ((() => {
                                                    const scoringRound = scoringRoundFillList.find(
                                                      (item) => item.round_id == data.round_id);
                                                    return scoringRound ? `${scoringRound.round_name}` : "";
                                                  })()
                                                  )}
                                                  </td>
                                                  <td>{this.state.editedScoringPatternRowIndex === index ? (
                                                    <select className="form-select border-input" name="TimeSlot"
                                                      value={scoringPatternDetail.scoring_mode_id || data.scoring_mode_id}
                                                      onChange={(e) => {
                                                        const selectedscoring_mode_id = e.target.value;
                                                        this.setState((prevState) => ({
                                                          scoringPatternDetail:
                                                          {
                                                            ...scoringPatternDetail, scoring_mode_id: selectedscoring_mode_id,
                                                          }, editedScoringPatternRowData: {
                                                            ...prevState.editedScoringPatternRowData,
                                                            scoring_mode_id: selectedscoring_mode_id,
                                                          },
                                                        }));
                                                      }}>
                                                      <option value="">--Select--</option>
                                                      {scoringModeFillList.map((data) => (
                                                        <option value={data.scoring_mode_id}>{data.scoring_mode}</option>
                                                      ))}
                                                    </select>
                                                  ) : (
                                                    (() => {
                                                      const scoringMode = scoringModeFillList.find((item) =>
                                                        item.scoring_mode_id == data.scoring_mode_id);
                                                      return scoringMode ? `${scoringMode.scoring_mode}` : "";
                                                    })()
                                                  )}
                                                  </td>
                                                  <td>
                                                    {editedScoringPatternRowIndex === index ? (
                                                      <select className="form-select border-input" name="TimeSlot"
                                                        value={scoringPatternDetail.section_fields_id || data.section_fields_id}
                                                        title={scoringPatternDetail.marking_pattern_name || data.marking_pattern_name}
                                                        onChange={(e) => {
                                                          const selectedValue = e.target.value;
                                                          const selectedField = applicationSectionFieldList.find(data => data.award_event_profile_section_fields_id == selectedValue);
                                                          if (selectedField) {
                                                            this.setState((prevState) => ({
                                                              scoringPatternDetail: {
                                                                ...scoringPatternDetail,
                                                                marking_pattern_name: selectedField.fieldname,
                                                                sp_name: selectedField.fieldname,
                                                                section_fields_id: selectedValue
                                                              }, editedScoringPatternRowData: {
                                                                ...prevState.editedScoringPatternRowData,
                                                                marking_pattern_name: selectedField.fieldname,
                                                                sp_name: selectedField.fieldname,
                                                                section_fields_id: selectedValue
                                                              },
                                                            }));
                                                          }
                                                        }}>
                                                        <option value="">--Select--</option>
                                                        {applicationSectionFieldList.map((data) => (
                                                          <option key={data.award_event_profile_section_fields_id} value={data.award_event_profile_section_fields_id} >
                                                            {data.fieldname}
                                                          </option>
                                                        ))}
                                                      </select>
                                                    ) :
                                                      ((() => {
                                                        const scoringFieldSelected = applicationSectionFieldList?.find(
                                                          (item) => item.award_event_profile_section_fields_id == data.section_fields_id);
                                                        return scoringFieldSelected ? `${scoringFieldSelected.fieldname}` : "";
                                                      })()
                                                      )
                                                    }
                                                  </td>
                                                  <td>
                                                    {editedScoringPatternRowIndex === index ? (
                                                      <input type="text" className="form-control border-input"
                                                        value={scoringPatternDetail.sp_name || editedScoringPatternRowData.sp_name}
                                                        onChange={(e) => {
                                                          const sp_nameValue = e.target.value;
                                                          this.setState((prevState) => ({
                                                            scoringPatternDetail: {
                                                              ...prevState.scoringPatternDetail,
                                                              sp_name: sp_nameValue,
                                                            },
                                                            editedScoringPatternRowData: {
                                                              ...prevState.editedScoringPatternRowData,
                                                              sp_name: sp_nameValue,
                                                            },
                                                          }));
                                                        }} />
                                                    ) : (data.sp_name)}
                                                  </td>
                                                  <td>
                                                    {editedScoringPatternRowIndex === index ? (
                                                      <input type="text" className="form-control border-input"
                                                        value={scoringPatternDetail.description || editedScoringPatternRowData.description}
                                                        onChange={(e) => {
                                                          const descriptionValue = e.target.value;
                                                          this.setState((prevState) => ({
                                                            scoringPatternDetail: {
                                                              ...prevState.scoringPatternDetail,
                                                              description: descriptionValue,
                                                            },
                                                            editedScoringPatternRowData: {
                                                              ...prevState.editedScoringPatternRowData,
                                                              description: descriptionValue,
                                                            },
                                                          }));
                                                        }}
                                                      />
                                                    ) : (data.description)}
                                                  </td>
                                                  <td>
                                                    {editedScoringPatternRowIndex === index ? (
                                                      <input type="text" className="form-control border-input"
                                                        value={scoringPatternDetail.max_score || editedScoringPatternRowData.max_score}
                                                        onChange={(e) => {
                                                          const max_scoreValue = e.target.value;
                                                          const numericValue = max_scoreValue
                                                            .replace(/[^0-9.]/g, "")
                                                            .replace(/(\..*)\./g, "$1");
                                                          this.setState((prevState) => ({
                                                            scoringPatternDetail: {
                                                              ...prevState.scoringPatternDetail,
                                                              max_score: numericValue,
                                                            },
                                                            editedScoringPatternRowData: {
                                                              ...prevState.editedScoringPatternRowData,
                                                              max_score: numericValue,
                                                            },
                                                          }));
                                                        }} />
                                                    ) : (data.max_score)}
                                                  </td>
                                                  <td>
                                                    {this.state.editedScoringPatternRowIndex === index ? (
                                                      <select className="form-select border-input" name="TimeSlot"
                                                        value={scoringPatternDetail.automated_type || data.automated_type}
                                                        onChange={(e) => {
                                                          const selectedautomated_type = e.target.value;
                                                          this.setState((prevState) => ({
                                                            scoringPatternDetail:
                                                              { ...scoringPatternDetail, automated_type: selectedautomated_type, },
                                                            editedScoringPatternRowData: {
                                                              ...prevState.editedScoringPatternRowData,
                                                              automated_type: selectedautomated_type,
                                                            },
                                                          }));
                                                        }}>
                                                        <option value="">--Select--</option>
                                                        {automatedTypeFillList.map((data) => (<option value={data.id}>{data.type}</option>
                                                        ))}</select>
                                                    ) : ((() => {
                                                      const scoringRound = automatedTypeFillList?.find(
                                                        (item) => item.id == data.automated_type);
                                                      return scoringRound ? `${scoringRound.type}` : "";
                                                    })()
                                                    )}
                                                  </td>
                                                  <td>
                                                    {editedScoringPatternRowIndex === index ? (
                                                      <input type="text" className="form-control border-input"
                                                        value={scoringPatternDetail.scoring_formula || editedScoringPatternRowData.scoring_formula}
                                                        onChange={(e) => {
                                                          const scoring_formulaValue = e.target.value;
                                                          this.setState((prevState) => ({
                                                            scoringPatternDetail: {
                                                              ...prevState.scoringPatternDetail,
                                                              scoring_formula: scoring_formulaValue,
                                                            },
                                                            editedScoringPatternRowData: {
                                                              ...prevState.editedScoringPatternRowData,
                                                              scoring_formula: scoring_formulaValue,
                                                            },
                                                          }));
                                                        }} />
                                                    ) : (data.scoring_formula)}
                                                  </td>
                                                  <td>
                                                    {(scoringPatternDetail.automated_type === 1 ||
                                                      editedScoringPatternRowData.automated_type === 1 ||
                                                      data.automated_type === 1) ? (
                                                      <></>
                                                    ) : (
                                                      <>
                                                        {(editedScoringPatternRowIndex === index) ? (
                                                          <><i onClick={() => {
                                                            if (
                                                              data.max_score === '' ||
                                                              data.max_score === null ||
                                                              editedScoringPatternRowData.max_score === '' ||
                                                              editedScoringPatternRowData.max_score === null
                                                            ) {
                                                              toastError('Please enter max score');
                                                            } else {
                                                              this.toggleOptionScoreOpen(index, data, 'edit');
                                                            }
                                                          }}
                                                            className="ri-edit-box-line text-primary"
                                                          ></i>
                                                          </>
                                                        ) : (
                                                          <i onClick={() => this.toggleOptionScoreView(data)} className="ri-eye-line"></i>
                                                        )}
                                                      </>
                                                    )}
                                                  </td>
                                                  {console.log(scoringPatternList)}
                                                  {juryReviewNotStarted ?
                                                    (<><td className="text-right">
                                                      {this.state.editedScoringPatternRowIndex ===
                                                        index ? (<><a title="Save" className="btn btn-sm padding_0"
                                                          onClick={() => this.saveEditedScoringPatternRow(index)}>
                                                          <i className="ri-save-line action_btn_table" />
                                                        </a>
                                                          <a title="Cancel" className="btn btn-sm padding_0"
                                                            onClick={() => this.cancelEditScoringPatternRow()}>
                                                            <i className="ri-close-line action_btn_table" />
                                                          </a>
                                                        </>
                                                      ) : (<><a title="Edit" className="btn btn-sm padding_0"
                                                        onClick={() => this.handleEditScoringPatternRow(index, data)}>
                                                        <i class="ri-edit-box-line text-primary" />
                                                      </a><a title="Delete" className="btn btn-sm delete_record padding_0"
                                                        onClick={() => this.handleDeleteScoringPatternRow(data)}>
                                                          <i class="ri-delete-bin-line" />
                                                        </a>
                                                      </>)}
                                                    </td></>)
                                                    : null}
                                                </tr>
                                              ))) : (showNewScoringPatternRow ? <></> : <tr><td colSpan="10">No data available.</td></tr>
                                            )}
                                            {showNewScoringPatternRow && (
                                              <tr>
                                                <td>
                                                  <select
                                                    className="form-select border-input"
                                                    name="TimeSlot"
                                                    value={
                                                      scoringPatternDetail.round_id
                                                    }
                                                    onChange={(e) => {
                                                      const selectedround_id =
                                                        e.target.value;
                                                      this.setState({
                                                        scoringPatternDetail: {
                                                          ...scoringPatternDetail,
                                                          round_id:
                                                            selectedround_id,
                                                        },
                                                      });
                                                    }}
                                                  >
                                                    <option value=''>Select</option>
                                                    {scoringRoundFillList.map((data) => (
                                                      <option value={data.round_id}>{data.round_name}</option>
                                                    ))}
                                                  </select>
                                                </td>
                                                <td>
                                                  <select
                                                    className="form-select border-input"
                                                    name="TimeSlot"
                                                    value={
                                                      scoringPatternDetail.scoring_mode_id
                                                    }
                                                    onChange={(e) => {
                                                      const selectedscoring_mode_id =
                                                        e.target.value;
                                                      this.setState({
                                                        scoringPatternDetail: {
                                                          ...scoringPatternDetail,
                                                          scoring_mode_id:
                                                            selectedscoring_mode_id,
                                                        },
                                                      });
                                                    }}
                                                  >
                                                    <option value="">
                                                      --Select--
                                                    </option>
                                                    {scoringModeFillList.map((data) => (
                                                      <option value={data.scoring_mode_id}>{data.scoring_mode}</option>
                                                    ))}
                                                  </select>
                                                </td>
                                                <td>
                                                  <select
                                                    className="form-select border-input"
                                                    name="TimeSlot"
                                                    value={scoringPatternDetail.section_fields_id}
                                                    title={scoringPatternDetail.marking_pattern_name}
                                                    onChange={(e) => {
                                                      const selectedValue = e.target.value;
                                                      const selectedField = applicationSectionFieldList.find(
                                                        (data) => data.award_event_profile_section_fields_id == selectedValue
                                                      );
                                                      if (selectedField) {
                                                        const marking_pattern_name = selectedField.fieldname;
                                                        this.setState({
                                                          scoringPatternDetail: {
                                                            ...scoringPatternDetail,
                                                            marking_pattern_name: marking_pattern_name,
                                                            section_fields_id: selectedValue,
                                                          },
                                                        });
                                                      }
                                                    }}
                                                  >
                                                    <option value="">--Select--</option>
                                                    {applicationSectionFieldList.map((data) => (
                                                      <option key={data.award_event_profile_section_fields_id} value={data.award_event_profile_section_fields_id}>
                                                        {data.fieldname}
                                                      </option>
                                                    ))}
                                                  </select>
                                                </td>

                                                <td>
                                                  <input type="text" className="form-control border-input"
                                                    value={scoringPatternDetail.sp_name != '' ? scoringPatternDetail.sp_name : scoringPatternDetail.marking_pattern_name}
                                                    disabled={scoringPatternDetail.scoring_mode_id == 1}
                                                    title={scoringPatternDetail.marking_pattern_name}
                                                    onChange={(e) =>
                                                      this.handleScoringPatternChange(
                                                        "sp_name",
                                                        e.target.value
                                                      )
                                                    }
                                                    placeholder="Scoring Pattern Name" />
                                                </td>
                                                <td>
                                                  <input type="text" className="form-control border-input"
                                                    value={scoringPatternDetail.description}
                                                    onChange={(e) =>
                                                      this.handleScoringPatternChange(
                                                        "description",
                                                        e.target.value
                                                      )
                                                    }
                                                    placeholder="Description" />
                                                </td>
                                                <td>
                                                  <input type="text" className="form-control border-input"
                                                    value={scoringPatternDetail.max_score}
                                                    onChange={(e) => {
                                                      const value = e.target.value;
                                                      const numericValue = value
                                                        .replace(/[^0-9.]/g, "")
                                                        .replace(/(\..*)\./g, "$1");
                                                      this.handleScoringPatternChange(
                                                        "max_score",
                                                        numericValue
                                                      )
                                                    }
                                                    }
                                                    placeholder="Max Score" />
                                                </td>
                                                <td>
                                                  <select
                                                    className="form-select border-input"
                                                    name="TimeSlot"
                                                    value={
                                                      scoringPatternDetail.automated_type
                                                    }
                                                    onChange={(e) => {
                                                      const selectedautomated_type =
                                                        e.target.value;
                                                      this.setState({
                                                        scoringPatternDetail: {
                                                          ...scoringPatternDetail,
                                                          automated_type:
                                                            selectedautomated_type,
                                                        },
                                                      });
                                                    }}
                                                  >
                                                    <option value="">
                                                      --Select--
                                                    </option>
                                                    {automatedTypeFillList.map((data) => (
                                                      <option value={data.id}>{data.type}</option>
                                                    ))}
                                                  </select>
                                                </td>
                                                <td>
                                                  <input type="text" className="form-control border-input"
                                                    value={scoringPatternDetail.scoring_formula}
                                                    onChange={(e) =>
                                                      this.handleScoringPatternChange(
                                                        "scoring_formula",
                                                        e.target.value
                                                      )
                                                    }
                                                    placeholder="Scoring Formula" />
                                                </td>
                                                <td>
                                                  {parseInt(scoringPatternDetail.automated_type) === 1 ? <></> : (() => {
                                                    const awardEventProfileSectionFieldsSP = applicationSectionFieldList.find(
                                                      (fieldID) =>
                                                        fieldID.award_event_profile_section_fields_id === parseInt(scoringPatternDetail?.section_fields_id)
                                                    )?.award_event_profile_section_fields_id;
                                                    const extractedOptions = applicationSectionFieldList
                                                      .filter(
                                                        (data) =>
                                                          data.award_event_profile_section_fields_id === awardEventProfileSectionFieldsSP
                                                      )
                                                      .flatMap((filteredData) => filteredData);
                                                    if (extractedOptions && extractedOptions.length > 0) {
                                                      return (
                                                        <i onClick={() => {
                                                          if (scoringPatternDetail.max_score === '' || scoringPatternDetail.max_score === null) {
                                                            toastError('Please enter max score');
                                                          } else {
                                                            this.toggleOptionScoreOpen(null, scoringPatternDetail, 'new');
                                                          }
                                                        }}
                                                          className="fa fa-pencil-square-o text-primary mr-1"
                                                        ></i>
                                                      );
                                                    } else {
                                                      return null;
                                                    }
                                                  })()}
                                                </td>
                                                {juryReviewNotStarted ? (
                                                  <td>
                                                    <button
                                                      className="btn btn-primary btn-md"
                                                      onClick={() =>
                                                        this.handleAddRowScoringPattern()
                                                      }>Add</button>
                                                  </td>
                                                ) : null}
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                        <div>
                                          {juryReviewNotStarted ? (
                                            (scoreLeft !== 0) ?
                                              (
                                                <a
                                                  href="javascript:void(0);"
                                                  className="btn btn-outline-primary btn-sm px-4 mb-3"
                                                  style={{ width: "auto" }}
                                                  onClick={() => this.toggleNewScoringPatternRow()}
                                                >
                                                  <span className="hidden-xs">
                                                    {showNewScoringPatternRow ? "Cancel" : "Add Row"}
                                                  </span>
                                                </a>
                                              ) : <></>) : null}
                                          {juryReviewNotStarted ?
                                            (scoreLeft === 0) ?
                                              (<><a href="javascript:void(0);"
                                                className="btn btn-outline-primary btn-sm px-4 mb-3 ml-2"
                                                style={{ width: 'auto' }}
                                                onClick={() => {
                                                  if (editedScoringPatternRowIndex === null) {
                                                    this.handleAPScoringPatternSubmit();
                                                  } else {
                                                    toastError('Kindly save the edited record');
                                                  }
                                                }}

                                              ><span className="hidden-xs">Save Scoring Pattern</span></a>
                                              </>
                                              ) : <></> : null}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </> : <>
                              <div className="pageMainBox">
                                <div class="page-header">
                                  <h4 class="page-title text-center">
                                    Kindly Fill the Award Profile Details to Proceed
                                  </h4>
                                </div>
                              </div></>}
                          </Tab.Pane>
                          <Tab.Pane eventKey="Milestone">
                            {award_event_profile_id ? <>
                              <div class="container-fluid">
                                <div className="company_info">
                                  <fieldset className="mt-3">
                                    <legend>Pricing</legend>
                                    <span className="text-danger text-start text-left d-block  mr-4 mb-2" style={{ fontSize: '14px', float: 'left', marginTop: '-6px' }}>
                                      Note: To Add or Remove Applicant Type will need to make changes from Profile Section.
                                    </span>
                                    <span className="text-danger text-start text-left d-block  mb-2" style={{ fontSize: '14px', marginTop: '22px' }}>
                                      Note: Add 0 If Pricing Not Applicable for that Applicant Type
                                    </span>
                                    <span className="text-danger text-start text-left d-block  mb-2" style={{ fontSize: '14px', marginTop: '22px' }}>
                                      Note: If GST Applicable then set Taxable Amount else set Gross Amount for that Applicant Type
                                    </span>
                                    <div className="row">
                                      <div className="col-md-12">
                                        <div className="custom_table">
                                          <table className="table details-table " id="tbl">
                                            <thead>
                                              <tr>
                                                <th style={{ width: "40%" }}>Applicant Type</th>
                                                <th style={{ width: "20%" }}>Price (IN INR)</th>
                                                <th style={{ width: "20%" }} className="text-center">Price (IN USD)</th>
                                                <th className="text-center" style={{ width: "2%" }}></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {applicationFeeList.length > 0 ? (
                                                applicationFeeList.map((data, index) => (
                                                  <tr key={index}>
                                                    <td>
                                                      {data.applicantType}
                                                    </td>
                                                    <td>
                                                      {editedPricingRowIndex === index ? (
                                                        <input
                                                          type="text"
                                                          className="form-control border-input"
                                                          value={editedPricingRowData.rate_inr}
                                                          onChange={(e) =>
                                                            this.handleRowEditFieldChangePricing(
                                                              index,
                                                              "rate_inr",
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      ) : (
                                                        data.rate_inr
                                                      )}
                                                    </td>
                                                    <td>
                                                      {editedPricingRowIndex === index ? (
                                                        <input
                                                          type="text"
                                                          className="form-control border-input"
                                                          value={editedPricingRowData.rate_usd}
                                                          onChange={(e) =>
                                                            this.handleRowEditFieldChangePricing(
                                                              index,
                                                              "rate_usd",
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      ) : (
                                                        data.rate_usd
                                                      )}
                                                    </td>
                                                    {/* Action Buttons */}
                                                    <td>
                                                      {editedPricingRowIndex === index ? (
                                                        <>
                                                          <a
                                                            title="Save Milestone"
                                                            className="mr-2"
                                                            onClick={() => this.saveEditedRowPricing(index)}
                                                          >
                                                            <i className="ri-save-line" />
                                                          </a>
                                                          <a
                                                            title="Cancel"
                                                            onClick={this.cancelEditRowPricing}
                                                          >
                                                            <i className="ri-close-line" />
                                                          </a>
                                                        </>
                                                      ) : (
                                                        <>
                                                          {publish_status ? <></> : <>
                                                            <a
                                                              title="Edit Milestone"
                                                              className="mr-2"
                                                              onClick={() =>
                                                                this.handleEditRowPricing(index, data)
                                                              }
                                                            >
                                                              <i class="fa fa-pencil-square-o text-primary mr-1" />
                                                            </a>
                                                          </>}
                                                        </>
                                                      )}
                                                    </td>
                                                  </tr>
                                                ))
                                              ) : (
                                                <tr>
                                                  <td colSpan="6">No data available.</td>
                                                </tr>
                                              )}

                                            </tbody>
                                          </table>
                                          {publish_status ? <></> : <>
                                            <div>
                                              <a
                                                href="javascript:void(0);"
                                                className="btn btn-outline-primary btn-sm px-4 mb-3 py-1"
                                                style={{ width: "auto" }}
                                                onClick={() => this.handleApplicationFeeSubmit()}
                                              >
                                                Save Pricing
                                              </a>

                                            </div>
                                          </>}
                                        </div>
                                      </div>
                                    </div>
                                  </fieldset>
                                  <fieldset>
                                    <legend>Milestone</legend>
                                    <div className="row">
                                      <div className="col-md-12">
                                        <div className="custom_table">
                                          <table className="table details-table " id="tbl">
                                            <thead>
                                              <tr>
                                                <th style={{ width: "3%" }}></th>
                                                <th style={{ width: "25%" }}>Stages</th>
                                                <th className="text-center" style={{ width: "5%" }}>Date</th>
                                                <th style={{ width: "7%" }} className="text-center">Visible to Applicant</th>
                                                <th style={{ width: "10%" }}>Stage Name for Applicant</th>
                                                <th className="text-right" style={{ width: "2%" }}></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {milestoneFillListAP.length > 0 ? (
                                                milestoneFillListAP.map((apdata, indexap) => (
                                                  <tr key={indexap}>
                                                    <td className="text-center">
                                                      <label
                                                        htmlFor={`milestoneapcheck${indexap}`}
                                                        className="lebel-dis"
                                                        style={{ color: "#979797" }}
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          id={`milestoneapcheck${indexap}`}
                                                          checked={apdata.isSelected}
                                                          onChange={(e) =>
                                                            this.handleMilestoneRowEditFieldChangeAP(
                                                              indexap,
                                                              "isSelected",
                                                              e.target.checked, apdata
                                                            )
                                                          }
                                                        />
                                                      </label>
                                                      <span></span>
                                                    </td>
                                                    {/* Milestone Name */}
                                                    <td>
                                                      {editedMilestoneRowIndexAP === indexap ? (
                                                        <input
                                                          type="text"
                                                          className="form-control border-input"
                                                          value={editedMilestoneRowDataAP.milestone_name}
                                                          onChange={(e) =>
                                                            this.handleMilestoneRowEditFieldChangeAP(
                                                              indexap,
                                                              "milestone_name",
                                                              e.target.value, apdata
                                                            )
                                                          }
                                                        />
                                                      ) : (
                                                        apdata.milestone_name
                                                      )}
                                                    </td>
                                                    {/* Milestone Date */}
                                                    <td className="text-center">
                                                      {editedMilestoneRowIndexAP === indexap ? (
                                                        <input
                                                          type="date"
                                                          value={
                                                            editedMilestoneRowDataAP.milestone_date && editedMilestoneRowDataAP.milestone_date !== ''
                                                              ? (() => {
                                                                const dateParts = editedMilestoneRowDataAP.milestone_date.split('-');
                                                                const day = dateParts[0];
                                                                const month = dateParts[1];
                                                                const year = dateParts[2];
                                                                return `${year}-${month}-${day}`; // Convert to yyyy-mm-dd
                                                              })()
                                                              : '' // Return empty string if milestone_date is empty
                                                          }
                                                          onChange={(e) => {
                                                            const updatedDate = e.target.value; // Get the new value in yyyy-mm-dd format
                                                            const [year, month, day] = updatedDate.split('-');
                                                            const formattedDate = `${day}-${month}-${year}`;

                                                            this.setState((prevState) => {
                                                              const milestoneFillList = Array.isArray(prevState.milestoneFillListAP)
                                                                ? [...prevState.milestoneFillListAP]
                                                                : [];

                                                              if (milestoneFillList[prevState.editedMilestoneRowIndexAP]) {
                                                                milestoneFillList[prevState.editedMilestoneRowIndexAP] = {
                                                                  ...milestoneFillList[prevState.editedMilestoneRowIndexAP],
                                                                  milestone_date: formattedDate, // Update milestone_date in dd-mm-yyyy format
                                                                };
                                                              }
                                                              return {
                                                                milestoneFillListAP: milestoneFillList,
                                                                editedMilestoneRowDataAP: {
                                                                  ...prevState.editedMilestoneRowDataAP,
                                                                  milestone_date: formattedDate, // Update the edited milestone date in dd-mm-yyyy format
                                                                },
                                                              };
                                                            });
                                                          }}
                                                          className="form-control border-input"
                                                        />
                                                      ) : apdata.milestone_date ? apdata.milestone_date : ("")}
                                                    </td>
                                                    <td>
                                                      <label
                                                        htmlFor={`VisibleCheckap${indexap}`}
                                                        className="lebel"
                                                        style={{ color: "#979797" }}
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          id={`VisibleCheckap${indexap}`}
                                                          checked={
                                                            editedMilestoneRowIndexAP === indexap
                                                              ? editedMilestoneRowDataAP.is_visible_to_applicant
                                                              : apdata.is_visible_to_applicant
                                                          }
                                                          onChange={(e) =>
                                                            this.handleMilestoneRowEditFieldChangeAP(
                                                              indexap,
                                                              "is_visible_to_applicant",
                                                              e.target.checked, apdata
                                                            )
                                                          }
                                                          disabled={editedMilestoneRowIndexAP !== indexap}
                                                        />
                                                      </label>
                                                      <span></span>
                                                    </td>
                                                    {/* Stage Name */}
                                                    <td className="text-center">
                                                      {editedMilestoneRowIndexAP === indexap ? (
                                                        <input
                                                          type="text"
                                                          className="form-control border-input"
                                                          value={editedMilestoneRowDataAP.stage_name}
                                                          onChange={(e) =>
                                                            this.handleMilestoneRowEditFieldChangeAP(
                                                              indexap,
                                                              "stage_name",
                                                              e.target.value, apdata
                                                            )
                                                          }
                                                        />
                                                      ) : (
                                                        apdata.stage_name
                                                      )}
                                                    </td>
                                                    {/* Action Buttons */}
                                                    <td className="text-center">
                                                      {editedMilestoneRowIndexAP === indexap ? (
                                                        <>
                                                          <a
                                                            title="Save Milestone"
                                                            className="mr-2"
                                                            onClick={() => this.saveEditedMilestoneRowAP(indexap)}
                                                          >
                                                            <i className="ri-save-line" />
                                                          </a>
                                                          <a
                                                            title="Cancel"
                                                            onClick={this.cancelEditMilestoneRowAP}
                                                          >
                                                            <i className="ri-close-line" />
                                                          </a>
                                                        </>
                                                      ) : (
                                                        <>
                                                          <a
                                                            title="Edit Milestone"
                                                            className="mr-2"
                                                            onClick={() =>
                                                              this.handleEditMilestoneRowAP(indexap, apdata)
                                                            }
                                                          >
                                                            <i class="fa fa-pencil-square-o text-primary mr-1" />
                                                          </a>
                                                          {apdata.is_fixed == true ? null : (
                                                            <>
                                                              <a title="Remove Milestone"
                                                                onClick={() =>
                                                                  this.handleDeleteMilestoneRowAP(indexap)
                                                                }
                                                              >
                                                                <i class="ri-delete-bin-line text-danger" />
                                                              </a>
                                                            </>
                                                          )}
                                                        </>
                                                      )}
                                                    </td>
                                                  </tr>
                                                ))
                                              ) : (
                                                <tr>
                                                  <td colSpan="6">No data available.</td>
                                                </tr>
                                              )}
                                              {/* Adding New Milestone */}
                                              {showNewMilestoneRowAP && (
                                                <tr>
                                                  <td></td>
                                                  <td>
                                                    <input
                                                      type="text"
                                                      className="form-control border-input"
                                                      value={milestoneDetailAP.milestone_name}
                                                      onChange={(e) =>
                                                        this.handleMilestoneDetailChangeAP(
                                                          "milestone_name",
                                                          e.target.value
                                                        )
                                                      }
                                                      placeholder="Stage Name"
                                                    />
                                                  </td>
                                                  <td>
                                                    <input
                                                      type="date"
                                                      value={milestoneDetailAP.milestone_date}
                                                      onChange={(e) =>
                                                        this.handleMilestoneDetailChangeAP(
                                                          "milestone_date",
                                                          e.target.value
                                                        )
                                                      }
                                                      className="form-control border-input"
                                                      disabled
                                                    />
                                                  </td>
                                                  <td>
                                                    <label
                                                      className="lebel-dis"
                                                      style={{ color: "#979797" }}
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        disabled
                                                        checked={milestoneDetailAP.is_visible_to_applicant}
                                                      />
                                                    </label>
                                                    <span></span>
                                                  </td>
                                                  <td>
                                                    <input
                                                      type="text"
                                                      disabled
                                                      className="form-control border-input"
                                                      value={milestoneDetailAP.stage_name}
                                                      placeholder="Stage Name for Applicant"
                                                    />
                                                  </td>
                                                  <td>
                                                    <button
                                                      className="btn btn-primary btn-sm px-3"
                                                      onClick={() => this.handleMileStoneMasterSubmit("AP")}
                                                    >
                                                      Add
                                                    </button>
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                          {publish_status ? <></> : <>
                                            <div>
                                              <a
                                                href="javascript:void(0);"
                                                className="btn btn-outline-primary btn-sm px-4 mb-3 py-1 mr-2"
                                                style={{ width: "auto" }}
                                                onClick={this.toggleNewMilestoneRowAP}
                                              >
                                                {showNewMilestoneRowAP ? "Cancel" : "Add Row"}
                                              </a>
                                              <a
                                                href="javascript:void(0);"
                                                className="btn btn-outline-primary btn-sm px-4 mb-3 py-1"
                                                style={{ width: "auto" }}
                                                onClick={() => this.handleAPMilestoneSubmit()}
                                              >
                                                Save Milestone
                                              </a>

                                            </div>
                                          </>}
                                        </div>
                                      </div>
                                    </div>
                                  </fieldset>
                                </div>
                              </div>
                            </> : <><div className="pageMainBox">
                              <div class="page-header">
                                <h4 class="page-title text-center">
                                  Kindly Fill the Award Profile Details to Proceed
                                </h4>
                              </div>
                            </div></>}
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </Modal.Body>
                </Modal>

                {/*section pop 1*/}
                <Modal show={isApplicationSectionModal1} size="md" style={{ top: '5rem', backdropFilter: 'blur(5px)' }}>
                  <Modal.Body>
                    <div className="container-fluid">
                      <div className="company_info">
                        <fieldset>
                          <legend>Add Dynamic Fields</legend>
                          <div className="outside_input_field">
                            <div className="row mb-3">
                              <div className="col-md-3">
                                <b>Search</b>
                              </div>
                              <div className="col-md-5">
                                <input
                                  type="text"
                                  className="form-control border-input"
                                  placeholder="Enter search term"
                                />
                              </div>
                              <div className="col-md-2">
                                <button
                                  className="btn btn-outline-primary btn-sm px-4 mb-3 py-1 d-flex align-items-center"
                                  style={{ width: "max-content" }}
                                >
                                  Search
                                </button>
                              </div>
                            </div>

                            <div id="myTable" className="mb-3">
                              <p>No record found</p>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                  </Modal.Body>

                  <Modal.Footer className="d-flex justify-content-end">
                    <div className="col-md-2">
                      <button
                        className="btn btn-primary btn-sm px-3 create_btn add_additional_days_btn mb-2"
                        style={{ width: "max-content" }}
                        onClick={() => this.toggleApplicationSectionModal1Close()}
                      >
                        Close
                      </button>
                    </div>
                    <div className="col-md-2">
                      <button
                        className="btn btn-primary btn-sm px-3 create_btn add_additional_days_btn mb-2"
                        style={{ width: "max-content" }}
                        onClick={() => this.toggleApplicationSectionModal2Open(award_event_profile_id, [], 'add')}
                      >
                        New
                      </button>
                    </div>
                  </Modal.Footer>
                </Modal>
                {/*section pop 2*/}

                <Modal show={isApplicationSectionModal2} style={{ backdropFilter: 'blur(5px)' }} size="lg">
                  <Modal.Body>
                    <div className="container-fluid">
                      <div className="company_info">
                        <fieldset>
                          <legend>Add Section</legend>
                          <div className="outside_input_field row">
                            {/* Section Name */}
                            <div className="form-group">
                              <label htmlFor="section_name">Section</label>
                              <select
                                className="form-control border-input"
                                name="section_name"
                                value={this.state.sectionFieldDetail.section_name}
                                onChange={this.handleFieldDetailChange}
                              >
                                <option value="">Select</option>
                                {applicationSectionNameList
                                  .filter((item) => item.award_event_profile_id === award_event_profile_id)
                                  .map((data) => (
                                    <option key={data.section_name} value={data.section_name}>
                                      {data.section_name}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            {/* Control Type */}
                            <div className="form-group">
                              <label htmlFor="controltype_id">
                                Control Type <span className="mendatory_class">*</span>
                              </label>
                              <select
                                className="form-control border-input"
                                name="controltype_id"
                                value={this.state.sectionFieldDetail.controltype_id}
                                onChange={this.handleFieldDetailChange}
                              >
                                <option value="">Select</option>
                                {controlTypeAPFillList.map((data) => (
                                  <option key={data.controltype_id} value={data.controltype_id}>
                                    {data.controltype}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {/* Field Name */}
                            <div className="form-group">
                              <label htmlFor="fieldname">
                                Field Name <span className="mendatory_class">*</span>
                              </label>
                              <input
                                type="text"
                                name="fieldname"
                                value={this.state.sectionFieldDetail.fieldname}
                                className="form-control border-input"
                                placeholder="Enter"
                                onChange={this.handleFieldDetailChange}
                              />
                            </div>

                            {/* Mandatory */}
                            <div className="form-group">
                              <label htmlFor="is_mandatory">Mandatory</label>
                              <select
                                className="form-control border-input"
                                name="is_mandatory"
                                value={this.state.sectionFieldDetail.is_mandatory}
                                onChange={this.handleFieldDetailChange}
                              >
                                <option value="">Select</option>
                                {mandatoryAPFillList.map((data) => (
                                  <option key={data.is_mandatory} value={data.is_mandatory}>
                                    {data.mandatory_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            {this.renderDynamicFields()}
                          </div>
                        </fieldset>
                      </div>
                    </div>

                  </Modal.Body>
                  <Modal.Footer>
                    <div className="d-flex justify-content-end mt-3">
                      <button type="button"
                        className="btn btn-warning mr-2 btn-sm"
                        onClick={() => this.SubmitSectionModal2()}
                      >Submit</button>
                      <button type="button"
                        className="btn btn-secondary btn-sm"
                        onClick={() => this.toggleApplicationSectionModal2Close()}
                      >Close</button>
                    </div>
                  </Modal.Footer>
                </Modal>
                <Modal show={isOptionScoreOpen} size="lg" style={{ backdropFilter: 'blur(5px)' }}>
                  <Modal.Body>
                    <div className="container-fluid">
                      <div className="company_info">
                        <fieldset>
                          <legend>Scoring Pattern Options</legend>
                          {optionsViewType === 3 ? <>
                            <div className="outside_input_field">
                              {modalOptionsDetails.length > 0 ? modalOptionsDetails.map((data, i) => (
                                <div key={i} className="form-group d-flex align-items-center" style={{ gap: "1rem" }}>
                                  {data.option !== null ? (
                                    <>
                                      <div className="row">
                                        <div className="col-6">
                                          <label htmlFor="section_name" style={{
                                            flex: "1",
                                            marginBottom: 0,
                                            whiteSpace: "nowrap",
                                            textAlign: "right",
                                          }}>
                                            {i + 1}: {data.option}
                                          </label>
                                        </div>
                                        <div className="col-4">
                                          <input
                                            type="text"
                                            value={data.score_value}
                                            className="form-control border-input"
                                            disabled={isOptionScoreOpenMode == 'view'}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (!isNaN(value) && Number(value) <= Number(data.max_score)) {
                                                this.handleScoreChange(i, e);
                                              } else { toastError(`Max score for this option is ${data.max_score}`) }
                                            }}
                                            placeholder="Score"
                                          />
                                        </div>
                                      </div>
                                    </>
                                  ) : <>
                                    No Options Found</>}
                                </div>
                              )) : (
                                <p>No options available.</p>
                              )}
                            </div>
                          </> : optionsViewType === 2 ? <>
                            <div className="outside_input_field">
                              {tickOptions.map((data, index) => (
                                <div key={index} className="field-row row mb-3 align-items-center">
                                  {isOptionScoreOpenMode == 'add' ? <>
                                    <div className="col-4">
                                      <select className="form-select border-input"
                                        value={data.no_of_ticks ?? ""} disabled={isOptionScoreOpenMode == 'view'}
                                        onChange={(e) => this.handleSelectChangeTickOptions(Number(e.target.value), index)}
                                      >
                                        <option value="">Select</option>
                                        {[...Array(modalOptionsDetails.length + 1).keys()]
                                          .reverse()
                                          .map((number) => (
                                            <option
                                              key={number}
                                              value={number}
                                              disabled={tickOptions.some((option, i) => option.no_of_ticks === number && i !== index)} // Disable if selected in another row
                                            >
                                              {number}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </> : <></>}
                                  <div className="col-4 text-center">
                                    <p className="mb-0"><b>{data.no_of_ticks}</b> No of Ticks</p>
                                  </div>
                                  <div className="col-3">
                                    <input
                                      type="text"
                                      placeholder="Enter score"
                                      className="form-control"
                                      value={data.score || ""} disabled={isOptionScoreOpenMode == 'view'}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (!isNaN(value) && Number(value) <= Number(data.max_score)) {
                                          this.handleInputChangeTickOptions(e.target.value, index)
                                        } else { toastError(`Max score for this option is ${data.max_score}`) }
                                      }}
                                    />
                                  </div>
                                  {index !== 0 && (
                                    <div className="col-1 text-start">
                                      {/* <button className="buttonIcon"> */}
                                      {isOptionScoreOpenMode == 'add' ? <>
                                        <i
                                          className="ri-delete-bin-line"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => this.removeRowTickOptions(index)}
                                        ></i>
                                      </> : <></>}
                                      {/* </button> */}
                                    </div>
                                  )}
                                </div>
                              ))}
                              {isOptionScoreOpenMode == 'add' ? <>
                                <div className="mt-3">
                                  <button className="btn btn-primary" onClick={this.addRowTickOptions}>
                                    Add Row
                                  </button>
                                </div>
                              </> : <></>}
                            </div>
                          </> : optionsViewType === 4 ? <>
                            <div className="outside_input_field">
                              {uploadOptions.map((data, index) => (
                                <div key={index} className="field-row row align-items-center mb-2">
                                  <div className="col-3">
                                    <p className="mb-0">{data.upload_format}</p>
                                  </div>
                                  <div className="col-4">
                                    <input
                                      type="text"
                                      placeholder={`Enter value for ${data.upload_format}`}
                                      className="form-control"
                                      value={data.score || ''}
                                      disabled={isOptionScoreOpenMode === 'view'}
                                      onChange={(e) => {
                                        let value = e.target.value;

                                        if (value === "") {
                                          const updatedUploadOptions = [...uploadOptions];
                                          updatedUploadOptions[index].score = "";
                                          this.setState({ uploadOptions: updatedUploadOptions });
                                          return;
                                        }
                                        if (/^\d*\.?\d*$/.test(value)) {
                                          let floatValue = parseFloat(value);

                                          if (!isNaN(floatValue) && floatValue <= Number(data.max_score)) {
                                            const updatedUploadOptions = [...uploadOptions];
                                            updatedUploadOptions[index].score = value; // Keep as string to preserve decimals
                                            this.setState({ uploadOptions: updatedUploadOptions });
                                          } else {
                                            toastError(`Max score for this option is ${data.max_score}`);
                                          }
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                          </> : <></>}
                          <span className="mendatory_class text-left">Enter 0 if not applicable</span>
                        </fieldset>
                      </div>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="d-flex justify-content-end mt-3">
                      {isOptionScoreOpenMode == 'add' ? <>
                        <button
                          type="button"
                          className="btn btn-warning mr-2 btn-sm"
                          onClick={this.submitScoringOptionScore} // Submit scores on click
                        >
                          Submit
                        </button>
                      </> : <></>}
                      <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        onClick={() => this.toggleOptionScoreClose()} // Close modal on click
                      >
                        Close
                      </button>
                    </div>
                  </Modal.Footer>
                </Modal>

                <div class="row">
                  <div class="">
                    <a
                      href="javascript:void(0);"
                      onClick={() => this.navigateBackAwardEventList()}
                      class="btn btn-outline-secondary btn px-4 mb-3 ml-2 btn-right"
                    >
                      Back
                    </a>

                  </div>
                </div>
              </div>
            </section >
          </main >
          <Footer />

          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    awardEventMilestone_insertUpdate_action, awardProfile_changeSeq_action,
    insert_milestoneMaster_action, awardEventJury_insertUpdate_action,
    insertUpdate_awardProfile_action, award_event_detail_action,
    fill_action, award_profile_detail_action, awardProfileMilestone_insertUpdate_action,
    insertUpdate_awardProfile_applicationSection_action, insertUpdate_awardProfile_scoringPattern_action,
    awardProfile_delete_action, awardProfile_formPublish_action, awardProfileApplicationFee_insertUpdate_action
  })(AwardEventDetail)
);
